"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8062],{

/***/ 6051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgArrowRight = function SvgArrowRight(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 14,
        viewBox: "0 0 8 14"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "m.313 12.045 5.113-5.112L.313 1.821A1.065 1.065 0 1 1 1.82.312L7.687 6.18a1.064 1.064 0 0 1 0 1.508L1.82 13.554a1.065 1.065 0 1 1-1.507-1.508"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRight);


/***/ }),

/***/ 96654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgArrowRight2 = function SvgArrowRight2(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 14,
        viewBox: "0 0 8 14"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "m.313 12.045 5.113-5.112L.313 1.821A1.065 1.065 0 1 1 1.82.312L7.687 6.18a1.064 1.064 0 0 1 0 1.508L1.82 13.554a1.065 1.065 0 1 1-1.507-1.508"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRight2);


/***/ }),

/***/ 48109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useContactSalesTypeform; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var contexts_generic_config_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3156);
/* harmony import */ var services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77784);
/* harmony import */ var services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var services_typeform_typeform_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15728);
/* harmony import */ var _constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13979);
/* harmony import */ var client_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53989);
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65023);







function useContactSalesTypeform(param) {
    var abTests = param.abTests, fallbackLink = param.fallbackLink;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isShowingTypeform = ref[0], setIsShowingTypeform = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(contexts_generic_config_context__WEBPACK_IMPORTED_MODULE_1__/* .GenericConfigContext */ .Z), forcePricing = ref1.forcePricing, useNewTypeformUSVariant = ref1.useNewTypeformUSVariant, cookies = ref1.cookies, forceCurrency = ref1.forceCurrency, cloudfrontViewerCountry = ref1.cloudfrontViewerCountry, isV13PricingVersion = ref1.isV13PricingVersion, testTypeformContactSales = ref1.testTypeformContactSales, forceTypeformContactSalesExperience = ref1.forceTypeformContactSalesExperience, contactSalesTestMode = ref1.contactSalesTestMode;
    var onCallback = function() {
        setIsShowingTypeform(false);
    };
    var displayTypeform = function() {
        var getNewVariantForTest = useNewTypeformUSVariant || (0,services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2__.shouldUseNewTypeformVariant)(abTests, true);
        var pricingData = {
            forcePricing: forcePricing,
            cookies: cookies,
            abTests: abTests,
            forceCurrency: forceCurrency,
            countryCode: cloudfrontViewerCountry,
            isV13PricingVersion: isV13PricingVersion
        };
        if ((0,services_typeform_typeform_service__WEBPACK_IMPORTED_MODULE_3__/* .shouldGetTypeformExperience */ .ap)({
            abTests: abTests,
            cloudfrontViewerCountry: cloudfrontViewerCountry,
            testTypeformContactSales: testTypeformContactSales,
            forceTypeformContactSalesExperience: forceTypeformContactSalesExperience,
            sendBigBrainEvent: true
        })) {
            try {
                setIsShowingTypeform(true);
                (0,_constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_4__/* .openContactSalesTypeform */ ._X)({
                    country: cloudfrontViewerCountry,
                    deviceType: _constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_4__/* .TYPEFORM_DESKTOP_DEVICE_TYPE */ .PM,
                    getNewVariantForTest: getNewVariantForTest,
                    isTest: contactSalesTestMode,
                    pricingData: pricingData,
                    onCloseCallback: onCallback,
                    onSubmitCallback: onCallback,
                    onReadyCallback: onCallback
                });
            } catch (e) {
                var bbEventParams = {
                    name: _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_6__.TYPEFORM_UNHANDLED_EXCEPTION
                };
                (0,client_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_5__/* .handleClientException */ .N)({
                    e: e,
                    bbEventParams: bbEventParams
                });
                window.location = fallbackLink;
            }
        }
    };
    return {
        isShowingTypeform: isShowingTypeform,
        displayTypeform: displayTypeform
    };
}


/***/ }),

/***/ 833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ badge_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/badge/badge-component.scss.js


var StyledBadgeComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e18e91rw0"
})("padding:1px 8px 2px 7px;border-radius:2px;background-color:", colors/* default.brand-yellow */.Z["brand-yellow"], ";font-size:0.6875rem;color:", colors/* default.black */.Z.black, ";&.has-stroke{padding-top:0px;padding-bottom:1px;}");

;// CONCATENATED MODULE: ./components/core/badge/badge-component.js










var BadgeComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BadgeComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BadgeComponent);
    function BadgeComponent() {
        (0,_class_call_check/* default */.Z)(this, BadgeComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BadgeComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, translate = _props.translate, badgeText = _props.badgeText, badgeColorName = _props.badgeColorName, badgeTextColorName = _props.badgeTextColorName, badgeStrokeColorName = _props.badgeStrokeColorName;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBadgeComponent, {
                    className: classnames_default()("core-badge-component", {
                        "has-stroke": badgeStrokeColorName
                    }),
                    style: {
                        backgroundColor: colors/* default */.Z[badgeColorName],
                        color: colors/* default */.Z[badgeTextColorName],
                        border: badgeStrokeColorName ? "1px solid ".concat(colors/* default */.Z[badgeStrokeColorName]) : "unset"
                    },
                    children: badgeText || translate("header.menuItem.popular")
                });
            }
        }
    ]);
    return BadgeComponent;
}(react.PureComponent);
/* harmony default export */ var badge_component = ((0,generic_config_context/* withGenericConfig */.P)(BadgeComponent));


/***/ }),

/***/ 18062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ base_header_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-component.scss.js


var StyledBaseHeaderComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ey2cu0a0"
})(".desktop-wrapper{display:block;}.mobile-wrapper{display:none;}@media (max-width:", vp_sizes/* HEADER_DESKTOP_MENU_MIN_WIDTH */.K0, "){.desktop-wrapper{display:none;}.mobile-wrapper{display:block;}}");

// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/basic-header-component.js + 1 modules
var basic_header_component = __webpack_require__(72491);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./components/core/picture-with-link/picture-with-link-component.js
var picture_with_link_component = __webpack_require__(94640);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/secondary-header/secondary-link-item/secondary-link-item-component.scss.js



var borderBottomSize = "1px";
var transparentBorderBottom = "".concat(borderBottomSize, " solid transparent");
var borderBottom = "".concat(borderBottomSize, " solid ").concat(colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME]);
var StyledSecondaryLinkItemComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e1w21yvw0"
})("cursor:pointer;display:flex;align-items:center;padding-top:", borderBottomSize, ";padding-left:16px;padding-right:16px;text-decoration:none;color:", colors/* default.asphalt */.Z.asphalt, ";transition:color 200ms ease;font-weight:300;font-size:0.875rem;line-height:24px;border-bottom:", transparentBorderBottom, ";&.selected{color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";border-bottom:", borderBottom, ";}&:hover{color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";}");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/secondary-header/secondary-link-item/secondary-link-item-component.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}






var SecondaryLinkItemComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SecondaryLinkItemComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SecondaryLinkItemComponent);
    function SecondaryLinkItemComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, SecondaryLinkItemComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onClick", function(e) {
            var url = _this.props.url;
            var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            BigBrain("track", bigbrain_event_types.SECONDARY_HEADER_LINK_CLICKED, {
                kind: url,
                info1: isKeyboardEvent ? "keyboard" : "mouse"
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(SecondaryLinkItemComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, url = _props.url, isSelected = _props.isSelected, translate = _props.translate;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSecondaryLinkItemComponent, {
                    href: url,
                    className: classnames_default()("secondary-link-item-component", {
                        selected: isSelected
                    }),
                    onClick: this.onClick,
                    children: translate(title)
                });
            }
        }
    ]);
    return SecondaryLinkItemComponent;
}(react.PureComponent);
/* harmony default export */ var secondary_link_item_component = ((0,generic_config_context/* withGenericConfig */.P)(SecondaryLinkItemComponent));

// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./utils/url.js
var url = __webpack_require__(8339);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/constants.js
var base_header_constants = __webpack_require__(48802);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/secondary-header/secondary-header-desktop/secondary-header-desktop-component.scss.js





var transparentBorder = "1px solid transparent";
var border = "1px solid ".concat(colors/* default.riverstone */.Z.riverstone);
var HEADER_CONTENT_HORIZONTAL_PADDING = "".concat(constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px");
var UNIFIED_HEADER_LOGO_TRANSITION = "opacity ".concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_FIRST_TRANSITION_DURATION */.Z.SECONDARY_HEADER_SCROLL_FIRST_TRANSITION_DURATION, "ms ease, transform ").concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_FIRST_TRANSITION_DURATION */.Z.SECONDARY_HEADER_SCROLL_FIRST_TRANSITION_DURATION, "ms ease");
var UNIFIED_HEADER_LINKS_TRANSITION = "opacity ".concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION */.Z.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION, "ms ease, transform ").concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION */.Z.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION, "ms ease");
var UNIFIED_HEADER_TRANSITION = "opacity ".concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION */.Z.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION, "ms ease");
var SECONDARY_HEADER_HEIGHT_WITH_BORDER = "".concat(constants/* default.SECONDARY_HEADER_HEIGHT */.Z.SECONDARY_HEADER_HEIGHT + 1, "px");
var SECONDARY_HEADER_HEIGHT = "".concat(constants/* default.SECONDARY_HEADER_HEIGHT */.Z.SECONDARY_HEADER_HEIGHT, "px");
var StyledSecondaryHeaderDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("nav", {
    target: "e1vliikj0"
})("display:flex;justify-content:center;width:100%;border-top:", border, ";border-bottom:", transparentBorder, ";transition:", UNIFIED_HEADER_TRANSITION, ";height:", SECONDARY_HEADER_HEIGHT_WITH_BORDER, ";background-color:", colors/* default.white */.Z.white, ";.secondary-header-desktop-content{height:100%;max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;width:100%;padding-left:", HEADER_CONTENT_HORIZONTAL_PADDING, ";padding-right:", HEADER_CONTENT_HORIZONTAL_PADDING, ";display:flex;.logo-wrapper{padding-right:16px;transition:", UNIFIED_HEADER_LOGO_TRANSITION, ";.secondary-header-logo-image{height:", SECONDARY_HEADER_HEIGHT, ";}}.links-wrapper{height:100%;display:flex;align-items:center;transition:", UNIFIED_HEADER_LINKS_TRANSITION, ";.secondary-link-item-wrapper{height:100%;display:flex;}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/secondary-header/secondary-header-desktop/secondary-header-desktop-component.js






function secondary_header_desktop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}









var SecondaryHeaderDesktopComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SecondaryHeaderDesktopComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SecondaryHeaderDesktopComponent);
    function SecondaryHeaderDesktopComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, SecondaryHeaderDesktopComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        secondary_header_desktop_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderLogo", function() {
            var _props = _this.props, pageClusterConfig = _props.pageClusterConfig, useProductMiniSiteConfig = _props.useProductMiniSiteConfig;
            var logo = (0,cluster_config_service/* getMiniSiteLogo */.o8)(pageClusterConfig, {
                useProductMiniSiteConfig: useProductMiniSiteConfig
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, {
                className: "secondary-header-logo-image",
                src: logo === null || logo === void 0 ? void 0 : logo.src,
                alt: logo === null || logo === void 0 ? void 0 : logo.alt,
                href: logo === null || logo === void 0 ? void 0 : logo.url
            });
        });
        secondary_header_desktop_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderLinks", function() {
            var _props = _this.props, pageClusterConfig = _props.pageClusterConfig, router = _props.router, useProductMiniSiteConfig = _props.useProductMiniSiteConfig;
            var links = (0,cluster_config_service/* getMiniSiteLinks */.J9)(pageClusterConfig, {
                useProductMiniSiteConfig: useProductMiniSiteConfig
            });
            return links.map(function(link, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "secondary-link-item-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_link_item_component, {
                        url: link === null || link === void 0 ? void 0 : link.url,
                        title: link === null || link === void 0 ? void 0 : link.text,
                        isSelected: (0,url.isSameUrlWithoutQueryParams)(link === null || link === void 0 ? void 0 : link.url, router === null || router === void 0 ? void 0 : router.asPath)
                    })
                }, index);
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(SecondaryHeaderDesktopComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSecondaryHeaderDesktopComponent, {
                    "aria-label": "Secondary",
                    className: "secondary-header-desktop-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "secondary-header-desktop-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "logo-wrapper",
                                children: this.renderLogo()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "links-wrapper",
                                children: this.renderLinks()
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return SecondaryHeaderDesktopComponent;
}(react.PureComponent);
/* harmony default export */ var secondary_header_desktop_component = ((0,router.withRouter)((0,generic_config_context/* withGenericConfig */.P)(SecondaryHeaderDesktopComponent)));

// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-service.js + 55 modules
var base_header_service = __webpack_require__(86700);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/base-header-desktop-component.scss.js







var BASIC_HEADER_HEIGHT = "".concat(constants/* default.BASIC_HEADER_HEIGHT */.Z.BASIC_HEADER_HEIGHT, "px");
var base_header_desktop_component_scss_SECONDARY_HEADER_HEIGHT = "".concat(constants/* default.SECONDARY_HEADER_HEIGHT */.Z.SECONDARY_HEADER_HEIGHT, "px");
var base_header_desktop_component_scss_UNIFIED_HEADER_TRANSITION = "opacity ".concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION */.Z.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION, "ms ease, transform ").concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION */.Z.SECONDARY_HEADER_SCROLL_FULL_TRANSITION_DURATION, "ms ease");
var UNIFIED_HEADER_TRANSITION_LINKS_DISSAPPEAR = "opacity ".concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_DISSAPEARING_LINKS_DURATION */.Z.SECONDARY_HEADER_SCROLL_DISSAPEARING_LINKS_DURATION, "ms ease, transform ").concat(base_header_constants/* default.SECONDARY_HEADER_SCROLL_DISSAPEARING_LINKS_DURATION */.Z.SECONDARY_HEADER_SCROLL_DISSAPEARING_LINKS_DURATION, "ms ease");
var SUBMENU_TRANSITION = "opacity 50ms ease";
var StyledBaseHeaderDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("header", {
    target: "e10outa10"
})("width:100%;.header-create-account-button-wrapper{padding-left:8px;.regular-button{height:40px;.button-component{display:flex;height:100%;align-items:center;font-size:0.8125rem;}}}.header-prominant-contact-sales-button-wrapper{padding-left:8px;.regular-button{height:40px;a{text-decoration:none;}.button-component{display:flex;height:100%;align-items:center;font-size:0.8125rem;}}}.header-button-wrapper{display:flex;align-items:center;padding-left:16px;.signup-button{height:40px;}}.signup-popup-wrapper{position:fixed;z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";top:", constants/* default.BASIC_HEADER_HEIGHT */.Z.BASIC_HEADER_HEIGHT + 12, "px;left:calc(\n      (100vw - ", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px) / 2 + ", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px -\n        ", constants/* default.SIGNUP_POPUP_SCREEN_WIDTH */.Z.SIGNUP_POPUP_SCREEN_WIDTH, "px - ", constants/* default.SIGNUP_POPUP_SCREEN_RIGHT_MARGIN */.Z.SIGNUP_POPUP_SCREEN_RIGHT_MARGIN, "px\n    );@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, "){left:calc(100vw - ", constants/* default.SIGNUP_POPUP_SCREEN_WIDTH */.Z.SIGNUP_POPUP_SCREEN_WIDTH, "px - ", constants/* default.SIGNUP_POPUP_SCREEN_RIGHT_MARGIN */.Z.SIGNUP_POPUP_SCREEN_RIGHT_MARGIN, "px);}}&.scroll-started{.secondary-header-wrapper{.secondary-header-desktop-component{border-bottom:1px solid ", colors/* default.riverstone */.Z.riverstone, ";}}}.products-switcher-wrapper{position:fixed;z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";top:", constants/* default.BASIC_HEADER_HEIGHT */.Z.BASIC_HEADER_HEIGHT + 12, ' + "px";left:calc(\n      (100vw - ', vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px) / 2 + ", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px -\n        ", constants/* default.PRODUCTS_SWITCHER_SCREEN_WIDTH */.Z.PRODUCTS_SWITCHER_SCREEN_WIDTH, "px - ", constants/* default.PRODUCTS_SWITCHER_SCREEN_RIGHT_MARGIN */.Z.PRODUCTS_SWITCHER_SCREEN_RIGHT_MARGIN, "px\n    );@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, "){left:calc(\n        100vw - ", constants/* default.PRODUCTS_SWITCHER_SCREEN_WIDTH */.Z.PRODUCTS_SWITCHER_SCREEN_WIDTH, "px - ", constants/* default.PRODUCTS_SWITCHER_SCREEN_RIGHT_MARGIN */.Z.PRODUCTS_SWITCHER_SCREEN_RIGHT_MARGIN, "px\n      );}height:", constants/* default.PRODUCTS_SWITCHER_SCREEN_HEIGHT */.Z.PRODUCTS_SWITCHER_SCREEN_HEIGHT, "px;width:", constants/* default.PRODUCTS_SWITCHER_SCREEN_WIDTH */.Z.PRODUCTS_SWITCHER_SCREEN_WIDTH, "px;border-radius:8px;background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";box-shadow:0px 4px 50px 0px rgba(0,0,0,0.2);}&.scrolled-threshold{.with-secondary-logo{.basic-header-content-wrapper{.basic-header-content{.main-logo-wrapper{opacity:0;visibility:hidden;pointer-events:none;position:absolute;}.secondary-logo-wrapper{opacity:1;visibility:visible;position:static;display:flex;pointer-events:auto;}}}}.base-header-desktop-content{.left-side-header-links{.absolute-main-links{opacity:0;visibility:hidden;pointer-events:none;transform:translateY(-8px);transition:", UNIFIED_HEADER_TRANSITION_LINKS_DISSAPPEAR, ";}.absolute-unified-links{opacity:1;visibility:visible;pointer-events:auto;transform:none;transition:", base_header_desktop_component_scss_UNIFIED_HEADER_TRANSITION, ";}}}.secondary-header-wrapper{pointer-events:none;.secondary-header-desktop-component{opacity:0;visibility:hidden;.logo-wrapper{opacity:0;visibility:hidden;transform:translateY(-5px);}.links-wrapper{opacity:0;visibility:hidden;transform:translateY(-5px);}}}}.base-header-desktop-content{flex-grow:1;display:flex;align-items:center;justify-content:flex-end;height:", BASIC_HEADER_HEIGHT, ";.left-side-header-links,.right-side-header-links{height:100%;display:flex;.link-item-with-menu-component-wrapper,.link-item-component-wrapper{display:flex;align-items:center;&.header-language-picker{justify-content:center;align-items:center;.language-picker-component{.selected-language{border-radius:8px;padding:0 16px;&:hover{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";}}.earth-icon{margin:0 6px;width:18px;height:18px;}.arrow-down-icon{height:7px;}.language-picker-dialog-component-wrapper{top:52px;}}}}}.left-side-header-links{flex-grow:1;flex-shrink:0;.absolute-unified-links,.absolute-main-links{position:absolute;display:flex;height:100%;}.absolute-main-links{opacity:1;visibility:visible;transition:", base_header_desktop_component_scss_UNIFIED_HEADER_TRANSITION, ";.submenu-enter{opacity:0.01;}.submenu-enter.submenu-enter-active{opacity:1;transition:", SUBMENU_TRANSITION, ";}.submenu-leave{opacity:1;}.submenu-leave.submenu-leave-active{opacity:0.01;transition:", SUBMENU_TRANSITION, ";}}.absolute-unified-links{opacity:0;visibility:hidden;pointer-events:none;transform:translateY(8px);transition:", UNIFIED_HEADER_TRANSITION_LINKS_DISSAPPEAR, ";}}.right-side-header-links{flex-shrink:0;}.header-button-wrapper{flex-shrink:0;}}.header-menu-component-wrapper{position:fixed;top:", BASIC_HEADER_HEIGHT, ";z-index:", z_index/* TOP_BAR */.sE, ";left:0;right:0;bottom:0;background-color:rgba(0,0,0,0.1);backdrop-filter:blur(4px);// currently not supported in Firefox\n    pointer-events:none;width:100%;overflow:auto;.menu-component-wrapper{pointer-events:all;}}.secondary-header-wrapper{height:", base_header_desktop_component_scss_SECONDARY_HEADER_HEIGHT, ";position:fixed;width:100%;z-index:", z_index/* TOP_BAR */.sE - 1, ";}.header-menu-component-wrapper.enhanced-products{.structured-header-menu-left-panel-items{.inner-menu-item{.inner-menu-item-subitems{max-height:246px;gap:8px;.inner-menu-item-subitem{padding:8px 0;.inner-menu-item-subitem-wrapper{display:flex;width:100%;.inner-menu-item-subitem-title-icon-and-arrow{display:flex;.inner-menu-item-subitem-title-icon{width:48px;height:48px;margin:0 10px;}width:100%;align-items:center;.inner-menu-item-subitem-title-and-subtitle{display:flex;flex-direction:column;width:100%;.inner-menu-item-subitem-title{line-height:24px;}.inner-menu-item-subitem-subtitle{line-height:24px;color:", colors/* default.asphalt */.Z.asphalt, ";font-size:0.8125rem;}}}}}}}}@media (max-width:", vp_sizes/* HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH */.lu, "){.structured-header-menu-left-panel-items{.inner-menu-item{.inner-menu-item-subitems{.inner-menu-item-subitem{.inner-menu-item-subitem-wrapper{.inner-menu-item-subitem-title-icon-and-arrow{.inner-menu-item-subitem-title-icon{width:32px;height:32px;margin:0 6px;}.inner-menu-item-subitem-title-and-subtitle{.inner-menu-item-subitem-title{line-height:20px;}.inner-menu-item-subitem-subtitle{line-height:20px;font-size:12px;}}.inner-menu-item-subitem-title-arrow{margin-right:8px;}}}}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/products-switcher/products-switcher.scss.js



var SEPARATOR_LINE_COLOR = "#d9d9d9";
var StyledProductsSwitcher = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1jpkpsg0"
})("padding:24px;.main-products-title-wrapper{margin-bottom:16px;.main-product-title{font-size:0.875rem;color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";font-weight:400;}}.main-products-wrapper{display:flex;flex-direction:column;}.separator-line{margin:16px 0 24px 0;height:1px;background-color:", SEPARATOR_LINE_COLOR, ";}.additional-products-title{font-size:0.875rem;font-weight:400;color:", colors/* default.asphalt */.Z.asphalt, ";margin-bottom:16px;}.additional-products-wrapper{display:flex;flex-direction:row;.product{.icon-wrapper{.picture-component{display:flex;height:20px;width:20px;}}}}.product{display:flex;gap:8px;align-items:center;font-size:0.875rem;font-weight:400;color:", colors/* default.asphalt */.Z.asphalt, ";padding:8px;border-radius:8px;text-decoration:none;.icon-wrapper{.picture-component{display:flex;height:32px;width:32px;}}:hover{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";}}");

// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/products-switcher/consts.js

var MAIN_PRODUCTS = [
    {
        name: "Work Management",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/WM.png",
        miniSiteLink: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler
    },
    {
        name: "Sales CRM",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/CRM.png",
        miniSiteLink: links/* CRM_MINI_SITE_LINK */.mgz
    },
    {
        name: "Dev",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/DEV.png",
        miniSiteLink: links/* SOFTWARE_MINI_SITE_LINK */.DDD
    }
];
var ADDITIONAL_PRODUCTS = [
    {
        name: "WorkForms",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/forms.png",
        miniSiteLink: links/* WORKFORMS_HOMEPAGE_LINK */.o2N
    },
    {
        name: "WorkCanvas",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/canvas.png",
        miniSiteLink: links/* CANVAS_HOMEPAGE_LINK */.gOl
    }
];

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/products-switcher/products-switcher.js
function products_switcher_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            products_switcher_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var ProductsSwitcher = function(props) {
    var translate = props.translate, setShowproductsSwithcer = props.setShowproductsSwithcer, showproductsSwithcer = props.showproductsSwithcer;
    var ref = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var onPopUpClose = function() {
            if (showproductsSwithcer) {
                setShowproductsSwithcer(false);
            }
        };
        var checkIfClickedOutside = function(e) {
            if (ref.current && !ref.current.contains(e.target)) {
                onPopUpClose();
            }
        };
        document.addEventListener("click", checkIfClickedOutside);
        return function() {
            document.removeEventListener("click", checkIfClickedOutside);
        };
    }, [
        showproductsSwithcer,
        setShowproductsSwithcer
    ]);
    var renderProduct = function(product, openInDifferentTab) {
        var linkProps = {
            href: product === null || product === void 0 ? void 0 : product.miniSiteLink,
            className: "product",
            onClick: function() {
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SWITCHER_PRODUCT_CLICKED, {
                    kind: product === null || product === void 0 ? void 0 : product.name
                });
            },
            onMouseEnter: function() {
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SWITCHER_PRODUCT_HOVERED, {
                    kind: product === null || product === void 0 ? void 0 : product.name
                });
            }
        };
        if (openInDifferentTab) {
            linkProps.target = "_blank";
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", _object_spread_props(_object_spread({}, linkProps), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "icon-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                        src: product === null || product === void 0 ? void 0 : product.iconLink,
                        alt: product === null || product === void 0 ? void 0 : product.name
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-name",
                    children: product === null || product === void 0 ? void 0 : product.name
                })
            ]
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductsSwitcher, {
        className: "products-switcher",
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "main-products-title-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "main-product-title",
                    children: translate("header.productsSwitcher.exploreFeaturedProducts")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "main-products-wrapper",
                children: MAIN_PRODUCTS.map(function(product, index) {
                    return renderProduct(product, false, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "separator-line"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "additional-products-title-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "additional-products-title",
                    children: [
                        translate("header.productsSwitcher.moreProducts"),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "additional-products-wrapper",
                children: ADDITIONAL_PRODUCTS.map(function(product, index) {
                    return renderProduct(product, true, index);
                })
            })
        ]
    });
};
/* harmony default export */ var products_switcher = ((0,generic_config_context/* withGenericConfig */.P)(ProductsSwitcher));

// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/link-item/link-item-component.js + 1 modules
var link_item_component = __webpack_require__(88838);
// EXTERNAL MODULE: ./services/ab-tests/acquisition-ab-test-service.js
var acquisition_ab_test_service = __webpack_require__(77784);
// EXTERNAL MODULE: ./services/monday-platform/existing-accounts-service.js
var existing_accounts_service = __webpack_require__(14124);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/link-item-with-menu/link-item-with-menu-component.scss.js



var StyledLinkItemWithMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1bm0d790"
})("cursor:pointer;display:flex;align-items:center;padding:8px 10px;color:", colors/* default.text-gray */.Z["text-gray"], ";transition:color 200ms ease;border-radius:8px;&:hover{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";}&.is-open,&:hover{color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";.link-item-with-menu-icon{path{fill:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";stroke:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";}}}&.is-open{.link-item-with-menu-icon{transform:rotate(180deg);}}.link-item-with-menu-title{font-size:0.875rem;margin-right:4px;}.link-item-with-menu-icon{height:7px;width:10px;transition:transform 200ms ease;path{fill:", colors/* default.mud */.Z.mud, ";stroke:", colors/* default.mud */.Z.mud, ";}}");

// EXTERNAL MODULE: ./static/svg/arrow-down.svg
var arrow_down = __webpack_require__(83900);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/link-item-with-menu/link-item-with-menu-component.js





function link_item_with_menu_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}







var LIST_ITEM_WITH_MENU_CLASS_NAME = "link-item-with-menu-component";
var HOVER_OPEN_MENU_WAIT_MILISECONDS = 500;
var LinkItemWithMenuComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LinkItemWithMenuComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LinkItemWithMenuComponent);
    function LinkItemWithMenuComponent(props) {
        (0,_class_call_check/* default */.Z)(this, LinkItemWithMenuComponent);
        var _this;
        _this = _super.call(this, props);
        link_item_with_menu_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onMouseLeave", function(event) {
            var _props = _this.props, isOpen = _props.isOpen, closeMenu = _props.closeMenu;
            _this.clearHoverOpenMenuTimeoutIfNeeded();
            if (isOpen) {
                var _event_target;
                closeMenu(event);
                event === null || event === void 0 ? void 0 : (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.blur();
            }
        });
        link_item_with_menu_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onMouseEnter", function(event) {
            var openMenu = _this.props.openMenu;
            _this._hoverTimeout = setTimeout(openMenu, _this.getHoverWaitTime());
        });
        link_item_with_menu_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getHoverWaitTime", function() {
            var shouldDelayMenuOpenOnHover = _this.props.shouldDelayMenuOpenOnHover;
            return shouldDelayMenuOpenOnHover ? HOVER_OPEN_MENU_WAIT_MILISECONDS : 0;
        });
        link_item_with_menu_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "clearHoverOpenMenuTimeoutIfNeeded", function() {
            if (_this._hoverTimeout) {
                clearTimeout(_this._hoverTimeout);
                _this._hoverTimeout = null;
            }
        });
        link_item_with_menu_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onClickAction", function(event) {
            var _props = _this.props, openMenu = _props.openMenu, isOpen = _props.isOpen, closeMenu = _props.closeMenu;
            if (isOpen) {
                closeMenu();
            } else {
                openMenu();
            }
        });
        link_item_with_menu_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "blurItem", function(e) {
            var _e_target_closest, _e_target;
            e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(".".concat(LIST_ITEM_WITH_MENU_CLASS_NAME))) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
        });
        link_item_with_menu_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onClick", function(e) {
            _this.blurItem(e);
            _this.onClickAction(e);
        });
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.onClickAction);
        _this._hoverTimeout = null;
        return _this;
    }
    (0,_create_class/* default */.Z)(LinkItemWithMenuComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, isOpen = _props.isOpen, translate = _props.translate, className = _props.className;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLinkItemWithMenuComponent, {
                    className: classnames_default()(LIST_ITEM_WITH_MENU_CLASS_NAME, className, {
                        "is-open": isOpen
                    }),
                    onKeyDown: this.onKeyDown,
                    onClick: this.onClick,
                    role: "link",
                    tabIndex: 0,
                    "aria-haspopup": "true",
                    "aria-expanded": isOpen,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "link-item-with-menu-title",
                            children: translate(title)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_down/* default */.Z, {
                            className: "link-item-with-menu-icon"
                        })
                    ]
                });
            }
        }
    ]);
    return LinkItemWithMenuComponent;
}(react.PureComponent);
LinkItemWithMenuComponent.defaultProps = {
    shouldDelayMenuOpenOnHover: false
};
/* harmony default export */ var link_item_with_menu_component = ((0,generic_config_context/* withGenericConfig */.P)(LinkItemWithMenuComponent));

// EXTERNAL MODULE: ./components/core/language-picker/language-picker-component.js + 7 modules
var language_picker_component = __webpack_require__(67053);
// EXTERNAL MODULE: ./components/core/language-picker/language-picker-service.js
var language_picker_service = __webpack_require__(42803);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.js + 1 modules
var regular_button = __webpack_require__(35662);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button.js + 17 modules
var button_button = __webpack_require__(11068);
// EXTERNAL MODULE: ./services/typeform/typeform-service.js
var typeform_service = __webpack_require__(15728);
// EXTERNAL MODULE: ./services/localization/localization-service.js
var localization_service = __webpack_require__(99952);
// EXTERNAL MODULE: ./client/services/hooks/use-contact-cales-typeform.js
var use_contact_cales_typeform = __webpack_require__(48109);
// EXTERNAL MODULE: ./client/services/gtm-service/gtm-service.js
var gtm_service = __webpack_require__(60775);
// EXTERNAL MODULE: ./constants/data-layer-event-types.js
var data_layer_event_types = __webpack_require__(34496);
var data_layer_event_types_default = /*#__PURE__*/__webpack_require__.n(data_layer_event_types);
// EXTERNAL MODULE: ./services/new-ab-tests/new-ab-tests-service.js
var new_ab_tests_service = __webpack_require__(41871);
// EXTERNAL MODULE: ./constants/new-ab-tests.js
var new_ab_tests = __webpack_require__(60734);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/base-header-menu/base-header-menu-component.scss.js


var StyledBaseHeaderMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "edqq9jd0"
})("width:100%;background-color:rgba(255,255,255,1);box-shadow:0px 18px 30px rgba(0,0,0,0.03);padding:16px 0px;.header-menu-items-wrapper{max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;width:100%;display:flex;flex-wrap:wrap;margin:auto;padding:0px 32px;.header-menu-item-component-wrapper{height:156px;width:20%;}}@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px){.header-menu-items-wrapper{.header-menu-item-component-wrapper{width:25%;}}}");

// EXTERNAL MODULE: ./components/core/badge/badge-component.js + 1 modules
var badge_component = __webpack_require__(833);
// EXTERNAL MODULE: ./static/svg/arrow-right2.svg
var arrow_right2 = __webpack_require__(96654);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/base-header-menu/header-menu-item/header-menu-item-component.scss.js


var StyledHeaderMenuItemComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "exmkqvt0"
})("display:flex;height:100%;width:100%;cursor:pointer;padding:0px 10px;align-items:center;transition:background-color 200ms ease;text-decoration:none;color:", colors/* default.black */.Z.black, ";&:hover{background-color:", colors/* default.highlight-blue */.Z["highlight-blue"], ";}.header-menu-item-content{display:flex;.menu-item-title-icon{flex-shrink:0;font-size:0.875rem;margin-right:16px;path{stroke:", colors/* default.iris */.Z.iris, ";}}.menu-item-text-wrapper{display:flex;flex-direction:column;.menu-item-title-wrapper{display:flex;.menu-item-title{font-weight:400;}.new-badge-component-wrapper{margin-left:8px;}}.menu-item-description{margin-top:8px;font-size:0.8125rem;line-height:20px;color:", colors/* default.asphalt */.Z.asphalt, ";}.menu-item-footer{display:flex;align-items:center;margin-top:16px;color:", colors/* default.iris */.Z.iris, ";font-size:0.6875rem;position:absolute;top:130px;svg{fill:currentColor;height:10px;margin-left:8px;}}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/base-header-menu/header-menu-item/header-menu-item-component.js






function header_menu_item_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}







var HeaderMenuItemComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HeaderMenuItemComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HeaderMenuItemComponent);
    function HeaderMenuItemComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, HeaderMenuItemComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        header_menu_item_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onClick", function(e) {
            var url = _this.props.url;
            var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            BigBrain("track", bigbrain_event_types.HEADER_SUBMENU_LINK_CLICKED, {
                kind: url,
                info1: isKeyboardEvent ? "keyboard" : "mouse"
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(HeaderMenuItemComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, Icon = _props.icon, title = _props.title, description = _props.description, url = _props.url, isPopular = _props.isPopular, translate = _props.translate, footer = _props.footer;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderMenuItemComponent, {
                    className: "header-menu-item-component",
                    href: url,
                    onClick: this.onClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "header-menu-item-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                className: "menu-item-title-icon"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "menu-item-text-wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "menu-item-title-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "menu-item-title",
                                                children: translate(title)
                                            }),
                                            isPopular && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "new-badge-component-wrapper",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_component/* default */.Z, {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "menu-item-description",
                                        children: translate(description)
                                    }),
                                    footer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "menu-item-footer",
                                        children: [
                                            translate(footer),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right2/* default */.Z, {})
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return HeaderMenuItemComponent;
}(react.PureComponent);
/* harmony default export */ var header_menu_item_component = ((0,generic_config_context/* withGenericConfig */.P)(HeaderMenuItemComponent));

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/base-header-menu/base-header-menu-component.js




function base_header_menu_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function base_header_menu_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            base_header_menu_component_define_property(target, key, source[key]);
        });
    }
    return target;
}




var BaseHeaderMenuComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseHeaderMenuComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseHeaderMenuComponent);
    function BaseHeaderMenuComponent() {
        (0,_class_call_check/* default */.Z)(this, BaseHeaderMenuComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BaseHeaderMenuComponent, [
        {
            key: "renderHeaderMenuItems",
            value: function renderHeaderMenuItems() {
                var menuItems = this.props.menuItems;
                return menuItems.map(function(menuItem, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "header-menu-item-component-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu_item_component, base_header_menu_component_object_spread({}, menuItem))
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBaseHeaderMenuComponent, {
                    className: "base-header-menu-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "header-menu-items-wrapper",
                        children: this.renderHeaderMenuItems()
                    })
                });
            }
        }
    ]);
    return BaseHeaderMenuComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./static/svg/header/header_subtitle_line.svg
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgHeaderSubtitleLine = function SvgHeaderSubtitleLine(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 6,
        height: 1,
        fill: "none",
        viewBox: "0 0 6 1"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#676879",
        strokeLinecap: "round",
        d: "M.25.75h5.5"
    })));
};
/* harmony default export */ var header_subtitle_line = (SvgHeaderSubtitleLine);

// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/header-menu-section/header-menu-section-component.scss.js



var StyledHeaderMenuSectionComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1rl3vti0"
})("height:100%;.header-menu-section-title{color:", colors/* default.asphalt */.Z.asphalt, ';font-weight:300;font-size:0.8125rem;display:flex;align-items:center;position:relative;&.with-underline{font-size:1rem;&:after{content:"";background:', colors/* default.mud */.Z.mud, ";opacity:0.1;top:24px;display:block;position:absolute;height:1px;width:calc(100% - 20px);margin-left:-8px;}}&.with-image-and-CTA{flex-direction:column;align-items:flex-start;gap:8px;margin-left:-16px;padding:12px 16px;border-bottom:1px solid ", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01], ";&:hover{border-radius:4px;border-color:transparent;background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";cursor:pointer;}.secondary-button{font-size:0.8125rem;}}.header-menu-section-title-line{margin-right:8px;stroke:", colors/* default.asphalt */.Z.asphalt, ";}.header-menu-section-title-image-and-cta{display:flex;width:100%;justify-content:space-between;align-items:center;.header-menu-section-title-image{height:26px;display:flex;}.secondary-button{margin-right:18px;}}}.header-menu-section-items-wrapper{margin:20px 0;display:grid;grid-auto-flow:column;grid-template-rows:repeat(var(--max-number-of-items-in-column),auto);}.header-menu-see-more-wrapper{margin-bottom:16px;display:flex;.secondary-button{.secondary-button-text{font-size:0.8125rem;}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js + 1 modules
var secondary_button = __webpack_require__(95736);
;// CONCATENATED MODULE: ./static/svg/bullet_checked_green.svg
var _circle, bullet_checked_green_path;
function bullet_checked_green_extends() {
    bullet_checked_green_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return bullet_checked_green_extends.apply(this, arguments);
}

var SvgBulletCheckedGreen = function SvgBulletCheckedGreen(props) {
    return /*#__PURE__*/ react.createElement("svg", bullet_checked_green_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _circle || (_circle = /*#__PURE__*/ react.createElement("circle", {
        cx: 10,
        cy: 10,
        r: 10,
        fill: "#CAF4E2",
        className: "circle"
    })), bullet_checked_green_path || (bullet_checked_green_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#037F4C",
        d: "M6.272 9.834a.756.756 0 0 0-1.054 0 .72.72 0 0 0 0 1.032l2.98 2.92a.756.756 0 0 0 1.053 0l5.96-5.84a.72.72 0 0 0 0-1.032.756.756 0 0 0-1.054 0l-5.433 5.324z",
        className: "mark"
    })));
};
/* harmony default export */ var bullet_checked_green = (SvgBulletCheckedGreen);

;// CONCATENATED MODULE: ./static/svg/bullet_plus_green_2.svg
var _g, _defs;
function bullet_plus_green_2_extends() {
    bullet_plus_green_2_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return bullet_plus_green_2_extends.apply(this, arguments);
}

var SvgBulletPlusGreen2 = function SvgBulletPlusGreen2(props) {
    return /*#__PURE__*/ react.createElement("svg", bullet_plus_green_2_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _g || (_g = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_562_26773)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#CAF4E2",
        d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10",
        className: "circle"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#037F4C",
        d: "M14.319 9.396q.681 0 .681.593v.044q0 .285-.154.44-.153.13-.527.131h-3.715v3.715q0 .374-.153.527-.133.154-.418.154h-.044q-.594 0-.593-.681v-3.715H5.68q-.374 0-.527-.131Q5 10.318 5 10.033v-.044q0-.594.681-.593h3.715V5.68q0-.681.593-.681h.044q.285 0 .418.154.153.153.153.527v3.715z",
        className: "mark"
    }))), _defs || (_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_562_26773"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h20v20H0z"
    })))));
};
/* harmony default export */ var bullet_plus_green_2 = (SvgBulletPlusGreen2);

// EXTERNAL MODULE: ./constants/localized-links.js
var localized_links = __webpack_require__(31182);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/consts.js


var _obj;
var MENU_ID_TO_EVENT_KIND_MAP = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, base_header_service/* SOLUTIONS_MENU_ID */.e1, "Products"), (0,src_define_property/* default */.Z)(_obj, base_header_service/* TEAMS_MENU_ID */.$Q, "Teams"), (0,src_define_property/* default */.Z)(_obj, base_header_service/* PLATFORM_MENU_ID */.wP, "Platform"), (0,src_define_property/* default */.Z)(_obj, base_header_service/* CUSTOMERS_MENU_ID */.xN, "Success stories"), (0,src_define_property/* default */.Z)(_obj, base_header_service/* RESOURCES_MENU_ID */.Gu, "Resources"), _obj);

// EXTERNAL MODULE: ./segments/desktop/constants.js
var desktop_constants = __webpack_require__(73759);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/constants.js
var SECTION_ITEM_HEIGHT = 98;
var SECTION_ITEM_WIDTH = 286; // includes 16 pixel padding (8 on each side)
var SECTION_ITEM_HORIZONTAL_MARGIN = 18;
var SECTION_ITEM_SMALL_HORIZONTAL_MARGIN = 8;
var SEPERATOR_RIGHT_MARGIN = 32;
var SEPERATOR_LEFT_MARGIN = 4;
var SEPERATOR_RIGHT_MARGIN_SMALL = 16;
var SEPERATOR_LEFT_MARGIN_SMALL = 4;
var SECTION_MARGIN_BETWEEN_COLUMNS = 8;
var SECTION_SMALL_MARGIN_BETWEEN_COLUMNS = 0;
var SECTION_ITEM_BOTTOM_MARGIN = 38;

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/header-menu-section-item/header-menu-section-item-component.scss.js






var SECTION_ITEM_HEIGHT_PX = "".concat(SECTION_ITEM_HEIGHT, "px");
var SECTION_ITEM_WIDTH_PX = "".concat(SECTION_ITEM_WIDTH, "px");
var SECTION_ITEM_HORIZONTAL_MARGIN_PX = "".concat(SECTION_ITEM_HORIZONTAL_MARGIN, "px");
var SECTION_ITEM_SMALL_HORIZONTAL_MARGIN_PX = "".concat(SECTION_ITEM_SMALL_HORIZONTAL_MARGIN, "px");
var StyledHeaderMenuSectionItemComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e13mtidn0"
})("width:", SECTION_ITEM_WIDTH_PX, ";height:", SECTION_ITEM_HEIGHT_PX, ";margin-right:", SECTION_ITEM_HORIZONTAL_MARGIN_PX, ";padding:16px 8px;background-color:var(--header-menu-section-item-background-color);&:hover{background-color:var(--header-menu-section-item-hover-background-color);}&.outline{border-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";}border-radius:4px;border-width:2px;border-style:solid;&:not(.outline){border-color:transparent;}&.secondary-product{width:340px;.menu-item-title{opacity:0.85;}}&.feature{width:280px;margin-bottom:14px;margin-right:14px;padding:16px 12px;.menu-item-title-icon{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";border:1px solid transparent;border-radius:2px;margin-right:12px;}&:hover{.menu-item-title-icon{border:", "1px solid ".concat(colors/* default */.Z[color_consts.LIGHT_WORK_OS_IRIS_COLOR_NAME]), ";}}}&.resource{width:274px;margin-bottom:14px;margin-right:28px;}&.story{height:unset;width:356px;padding:0;border:none;&:hover{", (0,desktop_constants.getComponentShadowFilter)(), "      // remove hover effect in safari because of this bug:https://monday.monday.com/boards/757661511/pulses/2181485781\n            @media not all and (min-resolution:0.001dpcm){@supports (-webkit-appearance:none){filter:unset;}}}&:not(:last-child){margin-bottom:20px;}img{width:100%;height:147px;background:", colors/* default.silver */.Z.silver, ";border-top-left-radius:4px;border-top-right-radius:4px;}.menu-item-text-wrapper{padding:8px 20px 16px;.menu-item-description{font-size:0.8125rem;line-height:19px;color:", colors/* default.mud */.Z.mud, ";}}}.menu-item-text-and-tags-wrapper{display:flex;align-items:center;}&.by-team{.header-menu-section-item-component{.header-menu-item-content{.menu-item-title-icon{margin-top:-4px;margin-right:8px;}}}}&.secondary-product{width:156px;height:54px;margin-bottom:12px;.header-menu-section-item-component .header-menu-item-content .menu-item-text-wrapper .menu-item-description{-webkit-line-clamp:3;}}.header-menu-section-item-component{display:flex;height:100%;width:100%;cursor:pointer;align-items:center;transition:background-color 200ms ease;text-decoration:none;color:", colors/* default.black */.Z.black, ";&:not([href]){cursor:default;}.header-menu-item-content{display:flex;&.has-image-instead-title{flex-direction:column;}.menu-item-title-icon{flex-shrink:0;font-size:0.875rem;margin-right:16px;&:not(.fill){path,rect,circle{stroke:var(--icon-color);}}}.menu-item-text-wrapper{display:flex;flex-direction:column;.menu-item-title-wrapper{display:flex;.menu-item-title{font-size:0.875rem;font-weight:400;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;line-height:20px;}.new-badge-component-wrapper{margin-left:8px;display:flex;align-items:center;}}.menu-item-description{margin-top:8px;font-size:0.8125rem;line-height:20px;color:", colors/* default.asphalt */.Z.asphalt, ";overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;/* number of lines to show */\n          -webkit-box-orient:vertical;}.menu-item-description-button{margin-top:16px;.secondary-button{font-size:0.8125rem;}}}}@media (max-width:", vp_sizes/* HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH */.lu, "){margin-right:", SECTION_ITEM_SMALL_HORIZONTAL_MARGIN_PX, ";}}@media (max-width:", vp_sizes/* MD_DESKTOP_WIDTH */.JF, "){&.story{width:280px;img{height:115px;}}}@media (max-width:", vp_sizes/* HEADER_DESKTOP_MENU_MID_WIDTH */.ko, "){&.story{width:240px;img{height:99px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/header-menu-section-item/header-menu-section-item-component.js




















var HeaderMenuSectionItemComponent = function(props) {
    var Icon = props.icon, iconType = props.iconType, iconColor = props.iconColor, imageSrc = props.imageSrc, topic = props.topic, title = props.title, subtitle = props.subtitle, SubtitleIcon = props.subtitleIcon, description = props.description, url = props.url, isPopular = props.isPopular, translate = props.translate, badgeText = props.badgeText, badgeColorName = props.badgeColorName, badgeTextColorName = props.badgeTextColorName, badgeStrokeColorName = props.badgeStrokeColorName, openInNewTab = props.openInNewTab, button = props.button, menuId = props.menuId, sectionId = props.sectionId, iconStrokeColor = props.iconStrokeColor, tags = props.tags, buttonText = props.buttonText, outline = props.outline, itemType = props.itemType, backgroundColor = props.backgroundColor, hoverBackgroundColor = props.hoverBackgroundColor, subtitleAboveItem = props.subtitleAboveItem, localeId = props.localeId, imageFloatingCaption = props.imageFloatingCaption;
    var localizedUrl = (0,react.useMemo)(function() {
        return (0,localized_links/* getLocalizedLink */.Lz)(url, localeId);
    }, [
        url,
        localeId
    ]);
    var onClick = (0,react.useCallback)(function(e) {
        var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
        (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).CLICK_MAIN_NAV, {
            click_text: translate(title),
            parent_category: MENU_ID_TO_EVENT_KIND_MAP[menuId]
        });
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SUBMENU_LINK_CLICKED, {
            kind: localizedUrl,
            info1: isKeyboardEvent ? "keyboard" : "mouse",
            info2: menuId,
            info3: sectionId
        });
    }, [
        localizedUrl,
        menuId,
        sectionId,
        title,
        translate
    ]);
    var onTagMouseEnter = function(tag, index) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_PRODUCT_TAG_HOVERED, {
            kind: translate(title),
            info1: translate(tag),
            info2: index
        });
    };
    var renderMenuItemText = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "menu-item-text-wrapper",
            children: [
                topic && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "menu-item-topic-wrapper",
                    children: translate(topic)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "menu-item-title-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "menu-item-title",
                            children: translate(title)
                        }),
                        isPopular && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "new-badge-component-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_component/* default */.Z, {
                                badgeText: translate(badgeText),
                                badgeColorName: badgeColorName,
                                badgeTextColorName: badgeTextColorName,
                                badgeStrokeColorName: badgeStrokeColorName
                            })
                        })
                    ]
                }),
                subtitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "menu-item-subtitle-wrapper",
                    children: [
                        SubtitleIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubtitleIcon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "menu-item-title",
                            children: translate(subtitle)
                        })
                    ]
                }),
                description && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "menu-item-description",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                        text: translate(description)
                    })
                }),
                button && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "menu-item-description-button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, {
                        buttonText: translate(buttonText || "header.menuItem.button.readMore"),
                        url: localizedUrl,
                        isOpenLinkInNewTab: openInNewTab
                    })
                })
            ]
        });
    };
    var renderTag = function(param) {
        var tag = param.tag, index = param.index;
        var tagsType = (tags === null || tags === void 0 ? void 0 : tags.tagsType) || base_header_service/* TAG_TYPES.DEFAULT */.qq.DEFAULT;
        var renderBulletTag = function() {
            var _tags_list;
            var BulletIcon = index === (tags === null || tags === void 0 ? void 0 : (_tags_list = tags.list) === null || _tags_list === void 0 ? void 0 : _tags_list.length) - 1 ? bullet_plus_green_2 : bullet_checked_green;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletIcon, {
                        className: "tag-bullet"
                    }),
                    translate(tag)
                ]
            });
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tag",
            onMouseEnter: function() {
                return onTagMouseEnter(tag, index);
            },
            children: tagsType === base_header_service/* TAG_TYPES.BULLET */.qq.BULLET ? renderBulletTag() : translate(tag)
        }, index);
    };
    var renderTags = function(param) {
        var className = param.className;
        return tags && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("tags-wrapper", className),
            style: {
                "--header-product-tag-background-color": tags.backgroundColor,
                "--header-product-tag-color": tags.color
            },
            children: [
                tags.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tags-title",
                    children: "".concat(translate(tags.title), ":")
                }),
                tags.list.map(function(tag, index) {
                    return renderTag({
                        tag: tag,
                        index: index
                    });
                })
            ]
        });
    };
    var getStyle = function() {
        var backgroundColorValue = backgroundColor || colors/* default */.Z[color_consts.WHITE_COLOR_NAME];
        var hoverBackgroundColorValue = hoverBackgroundColor || colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME];
        return {
            "--header-menu-section-item-background-color": backgroundColorValue,
            "--header-menu-section-item-hover-background-color": hoverBackgroundColorValue
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            subtitleAboveItem && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: translate(subtitleAboveItem)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderMenuSectionItemComponent, {
                className: classnames_default()("header-menu-section-item-component-wrapper", itemType, {
                    outline: outline
                }),
                style: getStyle(),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "header-menu-section-item-component",
                    href: localizedUrl,
                    onClick: onClick,
                    target: openInNewTab ? "_blank" : "_self",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "header-menu-item-content-and-tags-wrapper",
                        style: {
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("header-menu-item-content", {
                                    "has-image-instead-title": !!imageSrc,
                                    "no-description": !description
                                }),
                                children: [
                                    Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                        className: classnames_default()("menu-item-title-icon", iconType),
                                        style: {
                                            "--icon-color": colors/* default */.Z[iconColor || color_consts.WORK_OS_IRIS_COLOR_NAME],
                                            "--icon-stroke-color": iconStrokeColor
                                        }
                                    }),
                                    imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "menu-item-image-and-caption-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                src: imageSrc
                                            }),
                                            imageFloatingCaption && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "menu-item-image-floating-caption",
                                                children: translate(imageFloatingCaption)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "menu-item-text-and-tags-wrapper",
                                        children: [
                                            renderMenuItemText(),
                                            renderTags({
                                                className: "tags-next-to-logo"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            renderTags({
                                className: "tags-at-the-bottom"
                            })
                        ]
                    })
                })
            }, title)
        ]
    });
};
/* harmony default export */ var header_menu_section_item_component = ((0,generic_config_context/* withGenericConfig */.P)(HeaderMenuSectionItemComponent));
HeaderMenuSectionItemComponent.defaultProps = {
    iconType: base_header_service/* ICON_TYPES.outline */.Yp.outline
};

// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/header-menu-section/components/tags.scss.js




var BACKGROUND_COLOR_OPACITY = 0.08;
var StyledTags = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e65ul410"
})("display:flex;align-content:center;.tags-title-wrapper{margin-right:8px;align-self:center;}.tags-wrapper{display:flex;gap:4px;.tag{border-radius:4px;padding:4px 8px;color:", function(param) {
    var color = param.color;
    return colors/* default */.Z[color];
}, ";background-color:", function(param) {
    var color = param.color;
    return (0,general/* hexToRgba */.a7)(colors/* default */.Z[color || color_consts.BRAND_BLACK_TEXT_COLOR], BACKGROUND_COLOR_OPACITY);
}, ";}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/header-menu-section/components/tags.js


var Tags = function(param) {
    var tags = param.tags, translate = param.translate;
    var _tags_labels;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTags, {
        color: tags === null || tags === void 0 ? void 0 : tags.color,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tags-title-wrapper",
                children: translate("header.tabs.products.tags.bestFor")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tags-wrapper",
                children: tags === null || tags === void 0 ? void 0 : (_tags_labels = tags.labels) === null || _tags_labels === void 0 ? void 0 : _tags_labels.map(function(tag) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tag",
                        children: translate(tag)
                    }, tag);
                })
            })
        ]
    });
};
/* harmony default export */ var components_tags = (Tags);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/header-menu-section/header-menu-section-component.js
function header_menu_section_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function header_menu_section_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            header_menu_section_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function header_menu_section_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function header_menu_section_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        header_menu_section_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



















var MAX_NUMBER_OF_ITEMS_IN_COLUMN_DEFAULT = 3;
var HeaderMenuSectionComponent = function(props) {
    var menuSectionItems = props.menuSectionItems, maxNumberOfItemsInColumn = props.maxNumberOfItemsInColumn, title = props.title, subtitle = props.subtitle, seeMoreItem = props.seeMoreItem, translate = props.translate, classname = props.classname, titleLine = props.titleLine, titleImage = props.titleImage, titleCTA = props.titleCTA, tags = props.tags, titleUrl = props.titleUrl, menuId = props.menuId, id = props.id, withTitleUnderline = props.withTitleUnderline;
    var onButtonClicked = (0,react.useCallback)(function(event, url, eventInfo) {
        (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).CLICK_MAIN_NAV, {
            click_text: translate(titleCTA === null || titleCTA === void 0 ? void 0 : titleCTA.title),
            parent_category: MENU_ID_TO_EVENT_KIND_MAP[menuId]
        });
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SUBMENU_LINK_CLICKED, {
            kind: url,
            info1: eventInfo,
            info2: menuId,
            info3: id
        });
        event === null || event === void 0 ? void 0 : event.stopPropagation();
    }, [
        id,
        menuId,
        titleCTA === null || titleCTA === void 0 ? void 0 : titleCTA.title,
        translate
    ]);
    var getStyle = function(menuSectionItem) {
        var backgroundColor = menuSectionItem.backgroundColor, hoverBackgroundColor = menuSectionItem.hoverBackgroundColor;
        var backgroundColorValue = backgroundColor || colors/* default */.Z[color_consts.WHITE_COLOR_NAME];
        var hoverBackgroundColorValue = hoverBackgroundColor || colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME];
        return {
            "--header-menu-section-item-background-color": backgroundColorValue,
            "--header-menu-section-item-hover-background-color": hoverBackgroundColorValue
        };
    };
    var renderHeaderMenuItems = (0,react.useCallback)(function() {
        return menuSectionItems.map(function(menuSectionItem) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu_section_item_component, header_menu_section_component_object_spread_props(header_menu_section_component_object_spread({}, menuSectionItem), {
                menuId: menuId,
                sectionId: id
            }));
        });
    }, [
        menuSectionItems
    ]);
    var renderBtnFromConfig = (0,react.useCallback)(function(btnConfig) {
        if (!btnConfig) return null;
        var btnText = btnConfig.title, _buttonType = btnConfig.buttonType, buttonType = _buttonType === void 0 ? button_consts/* SECONDARY_BUTTON_TYPE */.jE : _buttonType, eventInfo = btnConfig.eventInfo, config = _object_without_properties(btnConfig, [
            "title",
            "buttonType",
            "eventInfo"
        ]);
        var buttonConfig = header_menu_section_component_object_spread({
            buttonText: translate(btnText),
            buttonType: buttonType,
            onClick: function(event) {
                return onButtonClicked(event, config === null || config === void 0 ? void 0 : config.url, eventInfo);
            }
        }, config);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, header_menu_section_component_object_spread({}, buttonConfig));
    }, [
        onButtonClicked,
        translate
    ]);
    var onTitleClick = function(e) {
        var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
        if (titleUrl) {
            (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).CLICK_MAIN_NAV, {
                click_text: id,
                parent_category: MENU_ID_TO_EVENT_KIND_MAP[menuId]
            });
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SUBMENU_LINK_CLICKED, {
                kind: titleUrl,
                info1: isKeyboardEvent ? "keyboard" : "mouse",
                info2: menuId,
                info3: id
            });
            window.location.href = titleUrl;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderMenuSectionComponent, {
        className: "header-menu-section-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("header-menu-section-title", {
                    "with-underline": withTitleUnderline,
                    "with-image-and-CTA": titleImage && titleCTA
                }),
                onClick: onTitleClick,
                children: [
                    (titleImage || titleCTA) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "header-menu-section-title-image-and-cta",
                        children: [
                            titleImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: titleUrl,
                                tabIndex: "-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                    src: titleImage,
                                    className: "header-menu-section-title-image"
                                })
                            }),
                            renderBtnFromConfig(titleCTA)
                        ]
                    }),
                    tags && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_tags, {
                        tags: tags,
                        translate: translate
                    }),
                    titleLine && /*#__PURE__*/ (0,jsx_runtime.jsx)(header_subtitle_line, {
                        className: "header-menu-section-title-line"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                        className: "header-menu-section-title-text",
                        text: translate(title)
                    })
                ]
            }),
            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header-menu-section-subtitle",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                    text: translate(subtitle)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("header-menu-section-items-wrapper", classname),
                style: {
                    "--max-number-of-items-in-column": maxNumberOfItemsInColumn
                },
                children: renderHeaderMenuItems()
            }),
            seeMoreItem && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header-menu-see-more-wrapper",
                children: renderBtnFromConfig(seeMoreItem)
            })
        ]
    });
};
/* harmony default export */ var header_menu_section_component = ((0,generic_config_context/* withGenericConfig */.P)(HeaderMenuSectionComponent));
HeaderMenuSectionComponent.defaultProps = {
    maxNumberOfItemsInColumn: MAX_NUMBER_OF_ITEMS_IN_COLUMN_DEFAULT
};

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/sections-header-menu-component.scss.js






var SEPERATOR_RIGHT_MARGIN_PX = "".concat(SEPERATOR_RIGHT_MARGIN, "px");
var SEPERATOR_RIGHT_MARGIN_SMALL_PX = "".concat(SEPERATOR_RIGHT_MARGIN_SMALL, "px");
var SEPERATOR_LEFT_MARGIN_PX = "".concat(SEPERATOR_LEFT_MARGIN, "px");
var SEPERATOR_LEFT_MARGIN_SMALL_PX = "".concat(SEPERATOR_LEFT_MARGIN_SMALL, "px");
var StyledSectionsHeaderMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eqe2t5w0"
})("width:100%;background-color:rgba(255,255,255,1);padding:0;box-shadow:none;.header-menu-sections-wrapper{max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;width:100%;height:100%;display:flex;margin:auto;padding:0px 32px;.sections-separator{border-right:1px solid;border-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";margin:32px ", SEPERATOR_RIGHT_MARGIN_PX, " 36px ", SEPERATOR_LEFT_MARGIN_PX, ";&.products{margin-right:80px;}&.mondayProducts{margin-right:64px;}}.header-menu-section-component-wrapper{padding:48px 0 0px;background-color:var(--section-background-color);min-height:400px;&.has-background-color{flex:1;padding-left:54px;padding-top:48px;padding-bottom:32px;}&.products:first-of-type{.header-menu-section-title{font-size:1.238rem;margin-bottom:16px;margin-right:80px;color:unset;font-weight:500;}.header-menu-section-subtitle{font-size:0.8125rem;line-height:20px;margin-right:50px;color:", colors/* default.asphalt */.Z.asphalt, ";}}&.products{width:312px;}&.mondayProducts{.menu-item-title{opacity:0.85;}padding-top:30px;.header-menu-section-items-wrapper.mondayProducts{margin-top:0;}}}}@media (max-width:", vp_sizes/* HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH */.lu, "){.header-menu-sections-wrapper{.sections-separator{margin-right:", SEPERATOR_RIGHT_MARGIN_SMALL_PX, ";margin-left:", SEPERATOR_LEFT_MARGIN_SMALL_PX, ";}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/sections-header-menu-component.js
function sections_header_menu_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sections_header_menu_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sections_header_menu_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function sections_header_menu_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sections_header_menu_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sections_header_menu_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var SectionsHeaderMenuComponent = function(props) {
    var menuItems = props.menuItems, menuId = props.menuId;
    var renderHeaderMenuSections = (0,react.useCallback)(function() {
        return menuItems.map(function(menuSection, index) {
            var backgroundColor = menuSection.backgroundColor, classname = menuSection.classname, noSeparator = menuSection.noSeparator, title = menuSection.title, hasFirstSeparator = menuSection.hasFirstSeparator;
            var isLastItem = menuItems.length - 1 === index;
            var hasBackgroundColor = !!backgroundColor;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    hasFirstSeparator && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("sections-separator", classname)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("header-menu-section-component-wrapper", classname, {
                            "has-background-color": hasBackgroundColor
                        }),
                        style: {
                            "--section-background-color": colors/* default */.Z[backgroundColor] || "transparent"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu_section_component, sections_header_menu_component_object_spread_props(sections_header_menu_component_object_spread({}, menuSection), {
                            menuId: menuId
                        }))
                    }, title),
                    !isLastItem && !noSeparator && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("sections-separator", classname)
                    })
                ]
            });
        });
    }, [
        menuItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSectionsHeaderMenuComponent, {
        className: "sections-header-menu-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "header-menu-sections-wrapper",
            children: renderHeaderMenuSections()
        })
    });
};
/* harmony default export */ var sections_header_menu_component = (SectionsHeaderMenuComponent);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-component.scss.js





var structured_header_menu_component_scss_SEPERATOR_RIGHT_MARGIN_PX = "".concat(SEPERATOR_RIGHT_MARGIN, "px");
var structured_header_menu_component_scss_SEPERATOR_LEFT_MARGIN_PX = "".concat(SEPERATOR_LEFT_MARGIN, "px");
var StyledStructuredHeaderMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1pegubm0"
})("width:100%;background-color:", colors/* default.white */.Z.white, ";display:flex;justify-content:center;&.with-left-panel{.structured-header-menu-content{padding-left:64px;}}.header-menu-section-item-component-wrapper{margin-left:-8px;}&.solutions,&.teams{.header-menu-section-items-wrapper{margin-top:16px;}}&.solutions,&.teams,&.platform{min-height:592px;}&.solutions,&.teams,&.customers,&.resources{.structured-header-menu\n    .structured-header-menu-top-part\n    .structured-header-menu-content\n    .header-menu-sections-wrapper{.header-menu-section-item-component-wrapper{margin-bottom:10px;}}}&.customers{.structured-header-menu\n    .structured-header-menu-top-part\n    .structured-header-menu-content\n    .header-menu-sections-wrapper{.header-menu-section-component-wrapper{margin-right:90px;&:nth-child(2){margin-right:30px;}}}}&.resources{.structured-header-menu\n    .structured-header-menu-top-part\n    .structured-header-menu-content\n    .header-menu-sections-wrapper{.header-menu-section-component-wrapper{margin-right:0px;&:nth-child(3){margin-right:30px;}.header-menu-section-title{margin-right:32px;}.header-menu-section-item-component-wrapper{margin-right:60px;}}}}.structured-header-menu{max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;width:100%;height:auto;display:flex;flex-direction:column;padding:0px 32px;.structured-header-menu-top-part{display:flex;height:100%;.structured-header-menu-content{width:100%;display:flex;.header-menu-sections-wrapper{max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;width:100%;height:100%;display:flex;margin:auto;.sections-separator{border-right:1px solid;border-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";margin:0 ", structured_header_menu_component_scss_SEPERATOR_RIGHT_MARGIN_PX, " 0 ", structured_header_menu_component_scss_SEPERATOR_LEFT_MARGIN_PX, ";&.products{margin-right:80px;}&.mondayProducts{margin-right:64px;}}.header-menu-section-component-wrapper{padding:48px 0 0px;background-color:var(--section-background-color);min-height:400px;margin-right:32px;&.has-background-color{flex:1;padding-left:54px;padding-top:48px;padding-bottom:32px;}.header-menu-section-title{.header-menu-section-title-text{margin-bottom:10px;}&.with-underline .header-menu-section-title-text{margin-bottom:6px;}}.header-menu-section-item-component-wrapper{&.inner-menu-bottom-item{height:unset;}&.story{width:280px;&:hover{filter:drop-shadow(0px 8px 24px rgba(29,140,242,0.08));}img{height:115px;}}&.feature{width:286px;margin-right:18px;margin-bottom:10px;.menu-item-title-icon{background-color:transparent;}&:hover{.menu-item-title-icon{border-color:", colors/* default */.Z[color_consts.TRANSPARENT_COLOR_NAME], ";}}}&.integration,&.addOn{height:68px;width:208px;.header-menu-section-item-component{.header-menu-item-content{.menu-item-title-icon{margin-right:8px;}&.has-image-instead-title{flex-direction:row;gap:8px;.picture-component{display:flex;width:40px;height:40px;border:1px solid ", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01], ";border-radius:4px;}}}svg{border:1px solid var(--icon-stroke-color);border-radius:4px;}}}}.header-menu-section-item-component{.header-menu-item-content{.menu-item-image-and-caption-wrapper{position:relative;.menu-item-image-floating-caption{position:absolute;bottom:12px;left:8px;padding:4px;background-color:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";font-size:12px;border-radius:4px;color:white;margin-right:8px;}}}}}}}}}@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, "){&.solutions,&.teams,&.platform{.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-left-panel{min-width:304px;}.structured-header-menu-content{padding-left:40px;.header-menu-sections-wrapper{.header-menu-section-component-wrapper{&.features{margin-right:8px;}}}}}}}&.solutions,&.teams{.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-content{.header-menu-sections-wrapper{.header-menu-section-component-wrapper{margin-right:8px;}}}}}}&.customers,&.resources{.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-content{.header-menu-sections-wrapper{.header-menu-section-component-wrapper{margin-right:10px;.header-menu-section-component{.header-menu-section-items-wrapper{.header-menu-section-item-component-wrapper{margin-right:32px;margin-bottom:10px;}}}}}}}}}&.customers{.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-content{.header-menu-sections-wrapper{.header-menu-section-component-wrapper{margin-right:20px;&:nth-child(2){margin-right:52x;}.header-menu-section-component{.header-menu-section-items-wrapper{.header-menu-section-item-component-wrapper{margin-right:20px;}}}}}}}}}}@media (max-width:", vp_sizes/* HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH */.lu, "){&.platform{.structured-header-menu{.structured-header-menu-top-part{.header-menu-section-item-component-wrapper{&.inner-menu-bottom-item{height:120px;.menu-item-description{-webkit-line-clamp:3;}}}}}}&.solutions,&.teams,&.platform{.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-content{padding-left:38px;}.structured-header-menu-left-panel{min-width:250px;.structured-header-menu-left-panel-items{.inner-menu-item{.inner-menu-item-title{font-size:0.875rem;}.inner-menu-item-subitems{.inner-menu-item-subitem{font-size:0.875rem;.inner-menu-item-subitem-title-and-icon{gap:8px;}}}}}.header-menu-section-item-component-wrapper{&.inner-menu-bottom-item{width:216px;}}}}}}&.customers,&.resources{.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-content{.header-menu-sections-wrapper{.header-menu-section-component-wrapper{margin-right:16px;.header-menu-section-component{.header-menu-section-items-wrapper{.header-menu-section-item-component-wrapper{width:274px;margin-right:0px;}}}}}}}}}&.customers{.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-content{.header-menu-sections-wrapper{.header-menu-section-component-wrapper{&:first-child{margin-right:20px;}&:nth-child(2){margin-right:22px;}.header-menu-section-component{.header-menu-section-items-wrapper{.header-menu-section-item-component-wrapper{margin-right:16px;}}}}}}}}}&.resources{.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-content{.header-menu-sections-wrapper{.header-menu-section-component-wrapper{margin-right:26px;&:nth-child(3){margin-right:38px;}}}}}}}.structured-header-menu{.structured-header-menu-top-part{.structured-header-menu-content{.header-menu-sections-wrapper{.header-menu-section-component-wrapper{&.has-background-color:last-child{padding-left:32px;}}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-content/structured-header-menu-content.scss.js


var StyledStructuredHeaderMenuContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erklsrt0"
})("display:flex;flex-direction:column;.structured-header-menu-content-title{font-size:1rem;color:", colors/* default.asphalt */.Z.asphalt, ';padding-top:48px;&:after{content:"";background:#323338;opacity:0.1;top:6px;display:block;position:relative;height:1px;margin-left:-8px;width:calc(100% - 40px);}}.header-menu-section-component-wrapper{.header-menu-sections-wrapper{display:flex;.header-menu-section-title{font-size:1rem;font-weight:300;}}&.integrations,&.addOns{.header-menu-section-items-wrapper{margin:8px 0 32px;}.header-menu-section-title{font-size:0.8125rem;font-weight:400;*{font-weight:400;}}}}');

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-content/structured-header-menu-content.js
function structured_header_menu_content_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function structured_header_menu_content_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            structured_header_menu_content_define_property(target, key, source[key]);
        });
    }
    return target;
}
function structured_header_menu_content_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function structured_header_menu_content_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        structured_header_menu_content_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var StructuredHeaderMenuContentComponent = function(props) {
    var menuId = props.menuId, id = props.id, _content = props.content, content = _content === void 0 ? {} : _content, translate = props.translate;
    var contentTitle = content.title, _menuSections = content.menuSections, menuSections = _menuSections === void 0 ? [] : _menuSections;
    var getStyle = function() {
        var backgroundColor = backgroundColor ? colors/* default */.Z[backgroundColor] : "transparent";
        return {
            "--section-background-color": backgroundColor
        };
    };
    var renderHeaderMenuSections = (0,react.useCallback)(function() {
        return menuSections.map(function(menuSection, index) {
            var backgroundColor = menuSection.backgroundColor, classname = menuSection.classname, noSeparator = menuSection.noSeparator, title = menuSection.title;
            var isLastItem = menuSections.length - 1 === index;
            var hasBackgroundColor = !!backgroundColor;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("header-menu-section-component-wrapper", classname, {
                            "has-background-color": hasBackgroundColor
                        }),
                        style: getStyle(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu_section_component, structured_header_menu_content_object_spread_props(structured_header_menu_content_object_spread({}, menuSection), {
                            menuId: menuId
                        }))
                    }, title),
                    !isLastItem && !noSeparator && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("sections-separator", classname)
                    })
                ]
            });
        });
    }, [
        menuSections
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStructuredHeaderMenuContentComponent, {
        className: "structured-header-menu-content",
        children: [
            contentTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "structured-header-menu-content-title",
                children: translate(contentTitle)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header-menu-sections-wrapper",
                children: renderHeaderMenuSections()
            })
        ]
    });
};
/* harmony default export */ var structured_header_menu_content = ((0,generic_config_context/* withGenericConfig */.P)(StructuredHeaderMenuContentComponent));

;// CONCATENATED MODULE: ./static/svg/header/expand_arrow_1.svg
var expand_arrow_1_path;
function expand_arrow_1_extends() {
    expand_arrow_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return expand_arrow_1_extends.apply(this, arguments);
}

var SvgExpandArrow1 = function SvgExpandArrow1(props) {
    return /*#__PURE__*/ react.createElement("svg", expand_arrow_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 11,
        height: 8,
        fill: "none",
        viewBox: "0 0 14 11"
    }, props), expand_arrow_1_path || (expand_arrow_1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#323338",
        d: "M0 .342h14L7.368 10.658z"
    })));
};
/* harmony default export */ var expand_arrow_1 = (SvgExpandArrow1);

// EXTERNAL MODULE: ./static/svg/arrow-right.svg
var arrow_right = __webpack_require__(6051);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./client/services/hooks/use-previous.js

function usePrevious(value) {
    var ref = (0,react.useRef)();
    (0,react.useEffect)(function() {
        ref.current = value; // assign the value of ref to the argument
    }, [
        value
    ]); // this code will run when the value of 'value' changes
    return ref.current; // in the end, return the current ref value.
}
/* harmony default export */ var use_previous = (usePrevious);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-left-panel/structured-header-menu-left-panel.scss.js



var COLLAPSE_TRANSITION_DURATION_IN_MIL_SEC = 150;
var ARROW_TRANSITION = "".concat(COLLAPSE_TRANSITION_DURATION_IN_MIL_SEC, "ms transform ease-in-out");
var PANEL_TRANSITION = "".concat(COLLAPSE_TRANSITION_DURATION_IN_MIL_SEC, "ms max-height ease-in-out,").concat(COLLAPSE_TRANSITION_DURATION_IN_MIL_SEC, "ms margin ease-in-out");
var StyledStructuredHeaderMenuLeftPanelComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "enjqqrt0"
})("min-width:320px;padding:24px 24px 24px 0;box-shadow:32px 0 40px -32px rgba(29,140,242,0.16);display:flex;flex-direction:column;justify-content:space-between;.structured-header-menu-left-panel-items{display:flex;flex-direction:column;.inner-menu-item{display:flex;flex-direction:column;border-top:", "1px solid ".concat(colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01]), ";// for keyboard focus outline visibility\n      margin:1px;&:last-child{border-bottom:1px solid ", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01], ";}&.collapsed{.inner-menu-item-subitems{max-height:170px;margin:0 0 16px;}}.inner-menu-item-title{padding:16px 0;font-size:1rem;font-weight:400;display:flex;gap:8px;align-items:center;justify-content:space-between;.expand-arrow{transform:rotate(-90deg);transition:", ARROW_TRANSITION, ";display:flex;margin-right:14px;&.down-direction{transform:rotate(0deg);}}}.inner-menu-item-subitems{display:flex;flex-direction:column;margin:0px;max-height:0px;overflow:hidden;transition:", PANEL_TRANSITION, ";.inner-menu-item-subitem{display:flex;justify-content:space-between;font-size:1rem;line-height:40px;padding-left:8px;border-top-right-radius:8px;border-bottom-right-radius:8px;// for keyboard focus outline visibility\n          margin:1px;&.selected{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";}.inner-menu-item-subitem-title-and-icon{align-items:center;display:flex;gap:16px;.inner-menu-item-subitem-title-icon{height:22px;width:22px;}.inner-menu-item-subitem-tag{font-size:0.6875rem;font-weight:400;color:", colors/* default */.Z[color_consts.DEV_DARKER_TINT_02], ";background-color:", colors/* default */.Z[color_consts.DEV_LIGHT_TINT_02], ";border-radius:2px;padding:1px 5px;line-height:normal;}}.inner-menu-item-subitem-title-arrow{margin-right:16px;.arrow-icon{path{fill:", colors/* default.asphalt */.Z.asphalt, ";}height:8px;}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-left-panel/structured-header-menu-left-panel.js
function structured_header_menu_left_panel_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function structured_header_menu_left_panel_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            structured_header_menu_left_panel_define_property(target, key, source[key]);
        });
    }
    return target;
}













var SUB_ITEM_HOVER_DEBOUNCE_RATE = 1000; // 1sec
var SUB_ITEM_CHANGED_BY = {
    DEFAULT: "default",
    USER: "user"
};
var subItemHoverAction = function(param) {
    var menuItem = param.menuItem, subMenuItem = param.subMenuItem, changedBy = param.changedBy;
    (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_LEFT_PANEL_SUBITEM_CONTENT_VIEWED, {
        kind: subMenuItem.id,
        info1: menuItem.id,
        info3: changedBy
    });
};
var debounceOnHover = debounce_default()(function(param) {
    var menuItem = param.menuItem, subMenuItem = param.subMenuItem, changedBy = param.changedBy;
    return subItemHoverAction({
        menuItem: menuItem,
        subMenuItem: subMenuItem,
        changedBy: changedBy
    });
}, SUB_ITEM_HOVER_DEBOUNCE_RATE);
var StructuredHeaderMenuLeftPanelComponent = function(props) {
    var menu = props.menu, menuId = props.menuId, innerMenuIndex = props.innerMenuIndex, onItemClick = props.onItemClick, innerMenuSubIndex = props.innerMenuSubIndex, setInnerMenuIndex = props.setInnerMenuIndex, setInnerMenuSubIndex = props.setInnerMenuSubIndex, translate = props.translate, hasSubItems = props.hasSubItems, itemsCollapsedState = props.itemsCollapsedState, enhancedProducts = props.enhancedProducts;
    var bottomItem = menu.bottomItem;
    var prevInnerMenuSubIndex = use_previous(innerMenuSubIndex);
    var onLeftPanelItemClick = function(param) {
        var itemIndex = param.itemIndex;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_LEFT_PANEL_ITEM_CLICKED, {
            kind: menu.items[itemIndex].id,
            info2: menuId,
            info3: itemsCollapsedState[itemIndex]
        });
        onItemClick(itemIndex);
    };
    var onSubItemClick = function(param) {
        var itemIndex = param.itemIndex, subItemIndex = param.subItemIndex;
        setInnerMenuSubIndex(subItemIndex);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_LEFT_PANEL_SUBITEM_CLICKED, {
            kind: menu.items[itemIndex].subItems[subItemIndex].id,
            info2: menuId
        });
    };
    (0,react.useEffect)(function() {
        if (hasSubItems(innerMenuIndex)) {
            var changedBy = prevInnerMenuSubIndex === undefined ? SUB_ITEM_CHANGED_BY.DEFAULT : SUB_ITEM_CHANGED_BY.USER;
            debounceOnHover({
                menuItem: menu.items[innerMenuIndex],
                subMenuItem: menu.items[innerMenuIndex].subItems[innerMenuSubIndex],
                changedBy: changedBy
            });
        }
    }, [
        innerMenuSubIndex,
        innerMenuIndex
    ]);
    var onSubItemHover = function(param) {
        var itemIndex = param.itemIndex, subItemIndex = param.subItemIndex;
        setInnerMenuIndex(itemIndex);
        setInnerMenuSubIndex(subItemIndex);
    };
    var renderSubItem = function(param) {
        var itemIndex = param.itemIndex, subItem = param.subItem, subItemIndex = param.subItemIndex;
        var icon = subItem.icon, title = subItem.title, subtitle = subItem.subtitle, hasBetaTag = subItem.hasBetaTag;
        var Icon = icon;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("inner-menu-item-subitem", {
                selected: itemIndex === innerMenuIndex && subItemIndex === innerMenuSubIndex
            }),
            onClick: function() {
                onSubItemClick({
                    itemIndex: itemIndex,
                    subItemIndex: subItemIndex
                });
            },
            onMouseEnter: function() {
                onSubItemHover({
                    itemIndex: itemIndex,
                    subItemIndex: subItemIndex
                });
            },
            onKeyPress: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(function() {
                return onSubItemClick({
                    itemIndex: itemIndex,
                    subItemIndex: subItemIndex
                });
            }),
            tabIndex: itemIndex === innerMenuIndex ? 0 : -1,
            children: [
                !enhancedProducts && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "inner-menu-item-subitem-title-and-icon",
                            children: [
                                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                    className: classnames_default()("inner-menu-item-subitem-title-icon")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: translate(title)
                                }),
                                hasBetaTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "inner-menu-item-subitem-tag",
                                    children: translate("header.tabs.solutions.byProduct.dev.beta")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inner-menu-item-subitem-title-arrow",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right/* default */.Z, {
                                className: "arrow-icon"
                            })
                        })
                    ]
                }),
                enhancedProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "inner-menu-item-subitem-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "inner-menu-item-subitem-title-icon-and-arrow",
                        children: [
                            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                className: classnames_default()("inner-menu-item-subitem-title-icon")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inner-menu-item-subitem-title-and-subtitle",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "inner-menu-item-subitem-title",
                                        children: translate(title)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inner-menu-item-subitem-subtitle",
                                        children: subtitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inner-menu-item-subitem-title-arrow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right/* default */.Z, {
                                    className: "arrow-icon"
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    var isItemArrowPointingDown = function(itemIndex) {
        return hasSubItems(itemIndex) && itemsCollapsedState[itemIndex];
    };
    var isExpandableItem = function(itemIndex) {
        if (hasSubItems(itemIndex)) {
            return false;
        }
        return true;
    };
    var renderItem = function(param) {
        var item = param.item, itemIndex = param.itemIndex;
        var isItemSelected = itemIndex === innerMenuIndex;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("inner-menu-item", {
                selected: isItemSelected,
                collapsed: itemsCollapsedState[itemIndex]
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "inner-menu-item-title",
                    onClick: function() {
                        return onLeftPanelItemClick({
                            itemIndex: itemIndex
                        });
                    },
                    onKeyPress: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(function() {
                        return onLeftPanelItemClick({
                            itemIndex: itemIndex
                        });
                    }),
                    tabIndex: 0,
                    children: [
                        translate(item === null || item === void 0 ? void 0 : item.title),
                        isExpandableItem(itemIndex) && /*#__PURE__*/ (0,jsx_runtime.jsx)(expand_arrow_1, {
                            className: classnames_default()("expand-arrow", {
                                "down-direction": isItemArrowPointingDown(itemIndex)
                            })
                        })
                    ]
                }),
                hasSubItems(itemIndex) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("inner-menu-item-subitems"),
                    children: item.subItems.map(function(subItem, subItemIndex) {
                        return renderSubItem({
                            itemIndex: itemIndex,
                            subItem: subItem,
                            subItemIndex: subItemIndex
                        });
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStructuredHeaderMenuLeftPanelComponent, {
        className: "structured-header-menu-left-panel",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "structured-header-menu-left-panel-items",
                children: menu.items.map(function(item, itemIndex) {
                    return renderItem({
                        item: item,
                        itemIndex: itemIndex
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: bottomItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu_section_item_component, structured_header_menu_left_panel_object_spread({}, bottomItem))
            })
        ]
    });
};
/* harmony default export */ var structured_header_menu_left_panel = ((0,generic_config_context/* withGenericConfig */.P)(StructuredHeaderMenuLeftPanelComponent));

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-bottom-part/structured-header-menu-bottom-part.scss.js



var StyledStructuredHeaderMenuBottomPartComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1pk6o4b0"
})("display:flex;padding:8px 0;border-top:", "1px solid ".concat(colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME]), ";.spacer{flex:1;}");

;// CONCATENATED MODULE: ./static/svg/header/customers/filled_star.svg
var filled_star_path, _path2, filled_star_g;
function filled_star_extends() {
    filled_star_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return filled_star_extends.apply(this, arguments);
}

var SvgFilledStar = function SvgFilledStar(props) {
    return /*#__PURE__*/ react.createElement("svg", filled_star_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 14 14"
    }, props), filled_star_path || (filled_star_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#C3C6D4",
        fillRule: "evenodd",
        d: "m7 10.043-4.114 2.62 1.22-4.723L.343 4.837l4.868-.3L7 0l1.789 4.538 4.868.299L9.894 7.94l1.22 4.723z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ react.createElement("mask", {
        id: "mask0_2436_172234",
        width: 14,
        height: 13,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path2 || (_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#C3C6D4",
        fillRule: "evenodd",
        d: "m7 10.043-4.114 2.62 1.22-4.723L.343 4.837l4.868-.3L7 0l1.789 4.538 4.868.299L9.894 7.94l1.22 4.723z",
        clipRule: "evenodd"
    }))), filled_star_g || (filled_star_g = /*#__PURE__*/ react.createElement("g", {
        mask: "url(#mask0_2436_172234)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#FFCB00",
        d: "m-.026-1.986 14.209-.043.05 17-14.208.043z"
    }))));
};
/* harmony default export */ var filled_star = (SvgFilledStar);

;// CONCATENATED MODULE: ./static/svg/header/customers/partially_filled_star.svg
var partially_filled_star_path, partially_filled_star_path2, partially_filled_star_g;
function partially_filled_star_extends() {
    partially_filled_star_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return partially_filled_star_extends.apply(this, arguments);
}

var SvgPartiallyFilledStar = function SvgPartiallyFilledStar(props) {
    return /*#__PURE__*/ react.createElement("svg", partially_filled_star_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 14 14"
    }, props), partially_filled_star_path || (partially_filled_star_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#C3C6D4",
        fillRule: "evenodd",
        d: "m7 10.043-4.114 2.62 1.22-4.723L.343 4.837l4.868-.3L7 0l1.789 4.538 4.868.299L9.894 7.94l1.22 4.723z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ react.createElement("mask", {
        id: "mask0_2436_172223",
        width: 14,
        height: 13,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, partially_filled_star_path2 || (partially_filled_star_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#C3C6D4",
        fillRule: "evenodd",
        d: "m7 10.043-4.114 2.62 1.22-4.723L.343 4.837l4.868-.3L7 0l1.789 4.538 4.868.299L9.894 7.94l1.22 4.723z",
        clipRule: "evenodd"
    }))), partially_filled_star_g || (partially_filled_star_g = /*#__PURE__*/ react.createElement("g", {
        mask: "url(#mask0_2436_172223)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#FFCB00",
        d: "m-.026-1.986 8.823-.026.05 17-8.822.026z"
    }))));
};
/* harmony default export */ var partially_filled_star = (SvgPartiallyFilledStar);

;// CONCATENATED MODULE: ./static/svg/header/customers/g2.svg
var g2_path, g2_defs;
function g2_extends() {
    g2_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return g2_extends.apply(this, arguments);
}

var SvgG2 = function SvgG2(props) {
    return /*#__PURE__*/ react.createElement("svg", g2_extends({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 34,
        height: 34,
        fill: "none",
        viewBox: "0 0 34 34"
    }, props), g2_path || (g2_path = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#pattern0)",
        d: "M0 0h34v34H0z"
    })), g2_defs || (g2_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("pattern", {
        id: "pattern0",
        width: 1,
        height: 1,
        patternContentUnits: "objectBoundingBox"
    }, /*#__PURE__*/ react.createElement("use", {
        xlinkHref: "#image0_2434_171328",
        transform: "scale(.0039)"
    })), /*#__PURE__*/ react.createElement("image", {
        xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAYAAABccqhmAAABdWlDQ1BrQ0dDb2xvclNwYWNlRGlzcGxheVAzAAAokXWQvUvDUBTFT6tS0DqIDh0cMolD1NIKdnFoKxRFMFQFq1OafgltfCQpUnETVyn4H1jBWXCwiFRwcXAQRAcR3Zw6KbhoeN6XVNoi3sfl/Ticc7lcwBtQGSv2AijplpFMxKS11Lrke4OHnlOqZrKooiwK/v276/PR9d5PiFlNu3YQ2U9cl84ul3aeAlN//V3Vn8maGv3f1EGNGRbgkYmVbYsJ3iUeMWgp4qrgvMvHgtMunzuelWSc+JZY0gpqhrhJLKc79HwHl4plrbWD2N6f1VeXxRzqUcxhEyYYilBRgQQF4X/8044/ji1yV2BQLo8CLMpESRETssTz0KFhEjJxCEHqkLhz634PrfvJbW3vFZhtcM4v2tpCAzidoZPV29p4BBgaAG7qTDVUR+qh9uZywPsJMJgChu8os2HmwiF3e38M6Hvh/GMM8B0CdpXzryPO7RqFn4Er/QcXKWq8UwZBywAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAABAKADAAQAAAABAAABAAAAAABEIjhzAAAiQ0lEQVR4Ae1dX6gdx3mfvcdW+1LCLQjbYJebNthSbGjdh7hWIIg6kaUn23XAD/WDmpjYaWwcNwE7hKCKEFJDgmMSE8c4jh/yIkiQ1RdZigOiYAcViluwLdmQRtQG103SS+hDqcS9p/Ob2Tlnzzm7Z2f238zO/Abu3T2zs7Mzv5nvm2++75uZTDCMHoHpoRv36UpM9HWycZP+nW2p63SqryLLr6ImTC/NEmRZfp/H7ey+LcTORTzPzr6jrrO0vBkdAtnoSpxogTWRSwJXxJ1tCUXU8pqJa5Yg2Vz63cfP7VmmU/GBEJI5KEYhr2QQM2jGcEMGEFgrLYzmIPapOCjH2iKhD0HgbVDRzKHIGHZ2zlBqaANpf++SAfSHrVXOM4KfXH3XErGHTuhW9Ssk2pb1y6UFcU7sXDmFZ5xGFBDycEsG4AF0RfSLBJ/P4T0Uxu8nJVOYnpfTGMUQyAyGbwwygIEwnx7af7eYTO5Uo3wmUiX4OrQxfTgh8ikDGUIdXO2fkwG0x7A0h5nSbmPjQakgu00mik2kL613h5GUDjoEsyorMoAqZBrEz4ieI30D9Na8MhXS3CgtDLu7P4AykZLBGqwcH5EBOAJWlnw+p8+OyvksxfsykLqKAzNQOoPLT5MRtAeVDKAFhmper0X8wy2y4atNEZhOXwYzyE6/+WTTLFJ/jwzAsQdwtHcEbJjkufKQUoEr3GQAlojNtPhC3CdfoULPEreBk2nFodQVZGcvvDTwt0f5OTKAmmYj4dcAFOZjMgLLdiEDqACqML+nCa8Co1FEQ09AiaCyqcgAlqBRc/yNq5+Stnsq9pawGfVPMoLS5iMDyGEh4Zf2j/giyQgW2jR5BqC1+nselahQubfQNaL+QatB3rxJM4DpkZsfF1M670RN6usrJxnB9EmsTEzVqShJBlBQ8HGev55A0ngK78Ldna+kaDpMjgFMj9zyfdmrKe6nQdputVT6gSuPpSQNJMMA9Kg/+SZ99d1oIsHUalqQintx9AygoN2nPT9Bam5c5USkgagZAEf9xt2fL2oEopcGomQABdPeQ+zJRKA1AhFLA9ExAC3y7znJuX7rbs8MighEainYKNZx7PfKrj/Z8xqJf+wtGWD5sdHLZHIytyIFWMBmRYpCAigo+mjXb9YP+JYLAhFNCUbPACjyu/Rcpu0MgUimBKOeAmgtP+f7nXVqZmSPgJ4SvKCmnfZvBZdytBKABj57XCLK3XmC61bJFejZ7PQbnx9jrUfJAKaHbz7N9fpj7G4Rl3mkeoFRMQAq+yImoBiqpvQCl+8Z01qC0egASPwxUEjkdYBeYGPPSaWbGklVRyEBUNM/kt7EYmoERmQhCJ4BKG46mbwgkaWyjwQ2JgS25SGnnwl9j4GgGQCJf0z9nWUtRWBnR+oEwj2jIFgdAIm/tDsxcmwIKPdhufVcoCFIBqB9+in2B9pnWCxnBLLHQ3UYCm4KwJHfuXfxhdEgMH0itJ2GgmIAJP7R9GQWtCkCgekEgmEAJP6mPYrvjQ6BgJhAEAxA2fmxjp+mvtH1ZRa4EQLBmAi9KwFnTj4k/kY9iS+NEoFNsTH5ppJ6PRffqwRA917Prc/P+0UggLUDfiUAnsLrtwPy634RmK0duHGfr4J4YwBqbzUewe2r3fndUBBQTEAeR+8peGEAuVMEt+z21Oj8bGAIyIHQ12ajgzMArfhQO/kE1gosDhHwisBDPrwFB1UCzjT+EHsYiAARWEZgcPPgYBLAXONP4l9udf4mAjkCuXlwOKXgYAxATPY8yn382NGJQA0CAysFB2EAVPrVNDofE4EiAgMqBXvXASjRn26+xeblPRGwQ2CANQO9SgCzeT/dfO0anKmIQBEB5S7crz6gVwYgJlffxXl/sUV5TwQcEIA+ALqzHkNvDID2/h5bjVmnhECv/gG96ABo70+pf7KuAyAg/QMuH+jjwJGreim8Flvo7NMLuB1m+qE/LM/sd/9dHs9YXwhI/wC1XuBI1wXoXALgzj5dN1HD/AxxX3eDEDd8WGfyR3+ir9dv6eve64T49ftCLF/1UyHeu6Tv/uOXQrz7K33//rv6SiahcRj0f/d7CnbPAA7fckHQ1XfQbqE+BoL/2CeEAJGDwEHUe68V4g8+1G1Z/ud3kmn8p2YcJ54X4uK/dZs/c1uHQOdTgU6nAPmKJor+65qwq2eG4A/coYn9j2/qKuf1+YCh4A/MhWFoBDZzq0BnR5F3JgHQ4afnvgCChzj/8U8Kcevt/YzuLlU4f06I44+4vMG0XSHQoYNQdxKAVlLw/L6uGtnks+9P9Rz+rvv9E70pE64Q//sIRndh8qauwSAxv2oHoYtdWAU6YQBK8cfdfeYN1PbOjPb3PSDER2/tfh7ftnwY/Y0ysG1ehsEVdRcmTygoEaCMhCLyn/9J/RSpMwXlICSd7KQGRgPS/H/rKQBt/s3BL33zU3cLgXn9bQdLHwcR+dTXhPjZS82LUtRfuDA4KCDfel2I136umUHajKAThWB7CQDuvoJr/JtTg3zTEATE/KGUeU0L/O9vtyN+MLim9YTyEYwRfyjHqR+3K0tTDMJ4rxOFYCsJgIq/lj1hTIRvqtp09Eddv3i8e8nm/DkhvnNMJDotaL2DULu1ANrjj4o/QxwuV8x9QRAPfDn8Ud/Uq+noj7p+47nuiR/lgjSAvPGN9IL0ENx4sE21G0sAHP0bwo6R8NN/I8She8JT7tVVqcnoD8J8WOoM+p7agDl97+tpOia1MAs2lwA4+teRy+pzzH8xWt17dHzEDwIzWvjVmpXHgPiPP9M/8ePrYDCwmqQYWkgBjRiAGv2FeChFrBvVGaP+se8K8ZgcofoeCRsV0OIlKNxctO6oM0b+rl2R1xUV0wEw2dQCthA7tL9RxRsxgHxlUmowu9cXRNDn/Ne9RM3eaDL6Y5rThNnhW8U/1xLDwpBiaCgFOJsB1eifZbeliLFTncc811+u6Ou/cB/9oeOwDSB4fOPVV1YdjIz7s63OBEwHTDe1RUq5FJCdvfCSLexI58wA8sUI1PyvQxnE34fJa903+3oG4vzJj9xyx1Th7Emt61j3Jhx7kA75V00vEA9iBnOAPsFmSoHlz6kxAOCspQAnBuA0Bcjn/veta9Pkn4H4+zJ5+QDXdfQ3Zfzht4X46Yvm1+oVxP/8t4RAuiriL74FgkZ6m2D2PbBJG1MaKZm76gKcGABH/5reYub7Tea+NVl7eQwidR39iwWtYgKG+F3diWGFwLt14fqtuhSxPnf2C7BmAGr0n4qDsSLXul7QPg9l8mpdWMsMIJ7bjM7rsitjAhjJXYkf30BZsBkJQzUCSgqw30rcmgHoLb7p81+KPIgfHn0289PSDAKMbDv6F6tUZALnz7n7E5i8ML3iRiQGjaqrWSNQ9Xwh3l4JOM2Oyq2+GJYRiJH4UUesums7+hexAhNAgDKvab6wCNgELB9OO0BPZ7VrkJUEoNf7c/Rf6VOxEj9G/z42/AATaKqdx+hv61iEvQPSDpv5eZy1KFgxADGZ3FmbU2oJoPCLTew3bYjRvymhmjy6vBrLiq1y1dVlucuyhpKXpb6ulgHQ9FfSoiB+W5t0yetBR/U1+jetNKQsmFVtif/8ueZTjKZlDPE95RhUrwys1wHoDT82Q6yjlzKB+G1FUS8FbPnRUEZ/4NxkSzTsFsSgEdAL9tbqAuoZAEQJKv80oGYeajsaja0j+h79gS8UfU0IH1hj9G9iXhxbO9mWV9IuJPh1m4euZQBK/Kff/xxuuPfGSvyoJUb/rjb7nKNmd9d0xDe5w2UZOwMxzBFQB/RMcE5H5eahaxmAsv0LQfEfkH72S/3saDNvLv930Pw3NdE1LT1G/bYbpID4sRnI0GVvWuch36tZH7CeAdD2r5sKo5PL6rYhG7irb0F8HlrzDwVf0w1CTb0N8Q9ddvP94K/Z1rppQCUDyG3/1wRfv74LaOb9MXn5FTHDvB9hSOVZF6M+ygymle6GoECgPtScIVDJAHLbP8X/GOb9IHJzoCe85IyjjDnxF91oqBEUxN92qTTqU7eMuJ400kmhfQKeLKtwNQOg9l9vL4WDK8YYIBpjKa852nsoAl+HFYjfxaa/nBcIH4pK6CpCqM9y+UL9nS8QKrMGlDIArf0XaYv/6KyYn45J9DdED3/70AikLfFD3Cfht2Ax5daAUgZA7b/Euemedi2aqNGrZlQM+bgsI/a7mlBN3Uj4jbpG4SW5QlC5879UiFO35QwgdfEfWv97jy5jFd5vMyrCdh+yCQzMFDv2uoSx1M2lTn7Tlq4QLGcAKZ/0i9Eq9P3lIepjm+4xeL25mlBN3bCgJ2Sm5peYm3x9s8wcuMIAXPcUa1KSoN/52CfcR6uhKjRG7ffHP2mvR8GoT7Nef71Jr+tZ8ApcYQBJL/01ir/+mqB5zhgZx3b0lcvojw1E1+0O3Bw5vmkQKDEHri4H1onMK2ldMfq7KqqGQAjE8dXPhafZr6u77egP5kbir0Oz/fOS/QIXJICkzX8hjv4Q+ZtuoNm+u7TP4dbb7fKgH78dTu1TbS5nsSQBKFvhSqLll6L8HdroP3bih/hvI02hnmYFIpgwQturzoX/yxDQeoDZkwUJIOn5P5x+QgkgimNfGJ/IX8QPp/PYBrgGdxngEzEGC0mXdbbNa0kPsMgAptMtkWW2WcWTzna0GqLGMRA/cLI9nQeelq4+AnXtMOTCprqyBPd8cXXgbAqg5v8i2wquvEMUKBS7vxH7Q3PjbdIGtvP/JnnXvWPLfOryifF5tujiP2MAqq5qB5EYa72mTphvdj0Crfnc2kdjVvgVK2bm8MW4Ie/Naschvzmeb0kdn9L1qRIXGMA8cjx16aCkUP6FEGDqi2neaqMADAH3FMtQ2OZ/zgAKkclggpHqwB3+q2vs4P5LEkcJOAVY347Q9eVhzgAKkeZh9FfsQOtb/Me8n3bwbrsapwA1eGpFIBIpBpCsAhCear4DdraJQelXxNH2DL/iO13eUwJYj2ZBETg3AxYi178dyVOI/9dv+a1MzKI/JBtfgRKABfJ6g5CcASToAYhRyvd2X7GK/pBo4MjkKxjPQl/fD/+7coOQjZtQTM0A8h/hl7vDEsJTzed2X1j6GpvoX2yemOtWrOdo77MtFD1XAuofiEgm+NT+QzzGNlcMRMAXArnSXzOA1CwAmP/vvc4X9HpnW46Q/vDnlyUC2Zb8l6gEgPn/3mtRfz+Bvup+cOdX5wjkSn8tAaRmAfA5/4fmH/vdMRABzwjA/L+hfQA8l2Toz/u0E+OwDm52OXSL83sVCORKwIqnsUb7tP/j0A4GIuAfgU0sCpIMIMFFQL7s/xD/aaP23/VZghkCxhNQcoNEgs+lqjGK/9hMJZRAy4pbS0j/n6uMR5DbmyNO7dNPPTYXVRD/8WfC6Aw4/Xhs26Z7Ry7bMhKA96IMVgCfFoCYtP+QpLCTkk9vymKnQTlQnuOPFGN5X4NAmkrAGlB6eYz5f0whxBOUoNsJaUoSentLB0DJALKt0MvZafl8mQB//X485j+M/iHtomw6CKSAh79mfvFqgQAlAAuQOkny3qVOsgkik5CPTsdWZJ+6OwiYxlCI9BiALx+AWBSAELEP3RN234Z04tPaEzY6hdJlcgqQ2kKgQvV52wCBkBR/VcWHFAAphaEWgfQkgFpIekrw7q96ynjAbDH6+95D0ba6kFKoEKxFiwygFiImUAhApB6Tgs2YBdl8axFIjwH43AdgbVME/jC0w1Nt4IJZkArBtUilxwDWwsGHpQhAlA7R7Fda2EIkpAAqBAuArN6mxwBgj2dwQwDbp4/1pB+UO5TTn9xQHyR1egxgEFgj+sgYzH51cD/wZZoFKzAiA6gApvNorEEYYxiD2a8OV0wFaBYsRWlDZNml0ieMJAJQoI3F7FfXWjQLliKUngTgyyXX1xqE0ma3iAzV39+i6KVJjFmQHoIFeKaX0mMAheoPeuvLBblpJcdo9qurK6QZKgQXUJIMYHppISb2H7588uF/MJbRB4o/KM5iDDQLzltVTv8pAczh6PduTGY0mP0gMscYuE5goVU3xM5uZDtVLNRv9Qd88n2dXDsG8TMGs99qqy/GQCE4FmlsseQd/0pRB+BzV97QFYEgihjMfnVkQrPgDCEzBdiexcR+g0M5sIGkj3Dr7WGPPJBQYjH71bXvvUe5WlBK/5IB7Fyswyq6577cgTH/9Lkr8bqGxOg/Rn//dXWqewZpJ92pgBr0jQRQB1Vcz335AgBFKNhCDCFv89UXXsmbBXcubmRn30lPAvBlCkRHDnEakILir4qJJG4W1BLAVHxQhU+U8T4tAaGtToMIHLPZr64DJ2wWxOCfTwEScwbCEVK+FIHokCGNOtBJhL7JZx0Rt32e4jqBfNDXDCAT59piOLr3cU6fr7D32jBcUjH6Y5uvWJ1+bNvXrBOwTR9FOj3oawaQmjMQGtCnHgAdLgSNe4z+/k2JM7Xtw/JB/6oCXjALbBZ+x32Lc/rgEehr9MPcE8ttf/aSP5wP3CFECEeWQSLy1Q4GfXwfePhsD1OWAa85A4AvwGTAzwbyqbde9+v4AikAjAjOST7Cd47Nv4oyGJv4kPcoASQRLD7yzQTmaMR+t22WAOgpAKqbmiUAnfy1n/ttaN8aaGBg/oCEj3t8E6MumLHPAGmwyBB9lmWQb2sHQMUAtC+AVgoM8u1QPuLTHGgwgEsqt64W4sTz/hZpoS3OnvQniZm+MNRVDvbG/2cuAaS4NRjMgb5HHjR6SGbBoTrh8nfQFiBCHwF6kJ/8yMeXPX1zPtjPGcDOzhlPpfH7Wd/TANQeU4EvHp/Pwf0i4u/rIMKhlZIQ/U/9OJ3RH61bMPvPGYBeFLTtr/U9fdlYAzx9fvZZ+KWnvnMt9AEgxiEDJED0gZRCwexfYAASgdQUgWh0dDpfoudyp6M+QBPjUFIARn/oHtAH0glykJ+vAJ4xgGQVgWj4V1/xq4Aqdr7Hvp62UhDE+D2JwRABjB+6h5TC0iA/YwAKg8LcICVMVCcIQRloQE+dCYAoz58zaPRzxeiflOIvh1HSuLEAIGaRARTmBv2gHnCuUAaiU4QS4Bjz2S+lqxjs2yz4/LdSE/3znj23ACBikQGkqggEEnBG8blCEGUoBnjFYZUaFIPGQ6/4fGz3qMOx79pvw9WnWRA6htQUf6a/7Fw5ZW5xXWAASjSYTs8XEyR1P7QGug5cMAEoBsduIsSGI994Trtdu2zD1YdZMEWzn+lnU3GxKP4jeoEBqHQpOgQZgCAF9D33NN9yucJE+Nw/jlM5iGnM8Wfmx4u7bMPVh1kQup7EFvzMu9qi+I/4VQaQqkOQQQlzzxADpAHoBSBGj2FKgFEfZYUEs7zIx8XzEaJ6V0zZmP1CbN8hylSi5F9hANnZC3IYFNtDlCfIb+DcgK46XNcVBCEVpYEQGQHKZEZ9lLUsuCyCghTQFVNO0exXxH9p/o9HpWuA//4jew/KY8M/Unw3mfv/+18h/lWqQe78KyF+7/fDrDbKdftfCvHnB4S4clmI3/6XECi3zwDCv/9vhfhr+Yc9Buuwu+HDQrzxL0L8xmI7yitXpPtqJsRH/6x5DaH4g3+Bb5ya16Ddm5j/n7kg/c0Xw4oEoB6XiAqLr0X+C6NOKN6B66DGSAqfASjYfJkMIerj29BRQNxHmWwCpBkoBG0C2gMKwTZmWih4kU+qoYKmJVtdDdNDN+4Tkz2vySebq08TicGIBsKy7dAhwAICgZILPg2YO/fV4YENNvHADjpVYr4tHn93v703HhgNmIxrwOj/8Kdd34or/c7OPfn0fqFepQwAKaaHb7kgVw3tW0id2g+MbtBgLyuxxoCDYQbvXdKuztBtNGUIwAEiO842xLkGXTJFF+JswpSBw7Ev2DOZMbStaxkh/r/8xv6y164qi1Rx2fRFOfH6h8rnKTwwzihNRh3f+BiF4W2yIGbbbzg64Vg0MAWE4sao2BwFRI5gDjG9fkuIvdfJv2v7Y4JgJrZ7I4KBQZR32T4MEhHaMemwav4zcFQzAGgMJ3selwnTnQYAJcw9QQhtRV3k5SsYCQZXEByYQkgBZkHbKQvS2U49MPp3ZUEICS/Xsuzu/qDqlXIloEydvFegQQyjDjoROhNDPwiAKdnuheDSHqmb/dBaUvwvLv9dbsBKBqASVmgOlzOJ/jdESCweYegPAZfTeczUbF1poFtIcbXfMiaShpfdf4tJ1jMA7TiwXXwh2Xu4j/70xWSr33vFMT2xNQuiMHVmwdTNfqbBajx71zIATgMMivkVne78uaVI/uwMAZfTeTAVqJLK0EbQFaQeasR/wLOWASj81igQksMXnQ57x0O8ZOgeAUgBUAjC3GcTQORlbQGdDdoq9SAteevEf8BTzwCwR4DiJKmjmdcfHQsupWUdjxC1RwAKQTgZ2QS0BUT9ooIW07TkzX45eCW+/8uw1jIAxUGoDFzEDR0MTKDY8RZT8FcbBGDnt5UCoJsx27mhPaj408hPpy/Xjf5IWMsAVG47l5/WufL/DAEwAXiYkQnMIOnsBlMBW7MgPmrMtMlu81WCvOXUfVLy6krU8V/+9jdyheBfJLtCcAWRPAIr2bCiDY4pdavfqvJgfDkCLqsF0Q6YDkAnkOpqvyKKcP0989YjxaiqezsJAG9bcpSqD0UbD0kAIw91At02sTELukwFqPjTbaDc+O2aw5oBqJVEVAaWo4p5KBWD5di0iYVZ0FYh2OY7cb0rj/6+csq2StYMQGXowFlsCxBNOkgCZALdNqerWbDbr481txM2yj9TOTcGAM5CKcBgt3oFE/jq5+gstIpM8xiXdQLNvxLLm3L0v/y0S2WcGABNghbQYh56XOpfYI+mhcACMIskWCdgqwuwyC7iJE6jP3BwYgAKOHAYSgH1feiH36ZysB4luxSYCuBsBIZ1CMjRf+fMugRlz5wZAKWAMhgr4oxyEL7pDM0RoCRVj5080Kdsy6+6F50ZgMpQzzO26zLnc4kA9AKcEjTvCiB+mFmBIUM1Ag3N9JV7AlZ/ST+ZHrlZ7haU+JZhdSAtP8feeljyOubdhZbr1OdvSE5YfEX7fh3Kz2an3/h8XaKy580ZAHcOLsOzPg7KLNi2Xfa1q881rhRwqsIiH3j2kfjr23bn8n4X018xw8YMAJlQCihC6XgPaQAHaEDDDSUXg7aaYBsvLOgh4dv1CCz6efnNI3aJV1O1YwCQAjb2nEx++/BVXO1jzLQAXm+pMgLM80H4r77Cpbz2PQcpYfc/0HT0RwatGAAyoBQAFDoIhhGkph+AvwQJv2kHajz3Nx9szQCQ0fTwzaflSsHDJlNeWyBgGEHMEoEZ8SnqN+8o8MXZvSxP+3lH7vrbPHTDAA7tv1tMJi/IYmw2LwrfXEAAykKsie/6JJ6Fjwz8g8q9DgGfPpGdfvPJthl2wgBQiOmRW74vLw+1LRDfX0LAWA2w5wBO6YFv/JgCiP71X7Q/nmxMde67rC0Vf8XidccAaBYs4trPfZEZYIqAEJriEOI9jiAD0ePoMZrydDt19x8uv59p4vVXVoTOGAAyp0KwDOKe4sAMrrtBmxJxdJlPnQGI3pxKjDMG4f3I0BcCrRV/xYJ1ygCQMRWCRXgHvocC0ZziC6bQ9cGeZnQ3B4xyhB+2gaXir+qU36YFuarpi5XvwSd5MsHxk5uVafigHwQw8hZHX0gJCJAUEJZP/0UcGEUxvHdp/sucHoxRHceLm0AnHYPEsNfdna90/cHOJQAUkFOBrpuJ+REB0anob/BsthrQvF11VTsHTV+uesx4IkAEHBCAzd9xpx/b3HthAMo5QS9P3LYtCNMRASJQgYAU/ds6/FTk3GBHoKqcluK1mWLa2lFhKVv+JAKpIfBsVya/MuB6kQDMh5SnknRaML95JQJEwAGBHkV/U4peGYD6yO6Vx+SVUwGDOK9EwA6B7S58/es+1TsDUHMX6bkkC0ImUNcafE4EZghMn+xr3j/7hLzpnQHgY/kc5kTxw7wnAkSgAgH4+new0Kci94XoQRgAvqj2LKM+YAF8/iACKwiARvS0eeVRHxGDMQBVeFQMig0GIkAEyhCQ8/4rjw0h+puPD8oAVMV2L98jP059gGkBXomARiBf5ddugw9XMAdlAChcQSnoWlamJwIRIwCl3wV5zPSwYXAGgOrlTkJPDFtVfo0IBIuA9PNvv7tPk9r1shjItiDcRcgWKaaLFgFo/Fts690WFy8SwKzQ6qBRegrO8OBNWggMrPEvA9erBIACTdXZAlc/xV2Fy5qHcdEiAGuYVIgPqfEvw9I7A0ChNBPgASNlDcS4KBFofaBHV6j4nQLktaB5sKvmZD4jQMCLua8KlyAYAAqnzYOXD9BRqKqpGB8BAp3u6NsFHkFMAYoV4XSgiAbvI0IgOOIHtsExABSKTAAoMESEQJDED3yDZAAoGJkAUGCIAIFgiR/YBssAUDjFBCZ7XpO33GIcgDCMDYGgiR9gBqMELGtZKgbLUGHcKBBQ23l1d4RXX3UOWgIwldbTAToLGTx4DRyBQJx8bFAKWgIwFdB+AthLgG7DBhNeA0VAuff69/CzRWcUEkCxMlxAVESD90EhkPv2qwErqIJVF2Z0DABV4dFj1Q3KJ94Q6OXorr5rM0oGAFCmh/bfLQ8hfUHe0kLQdy9h/usQkLtbyc08PK3nX1cwm2ejZQCoHH0FbJqYaXpDQCn7cGzX8Dv5dFWnUSgBqyqrlYNyj0EqB6sgYnxfCMyUfeMlfkAzagmg2La5cvA+GccpQREY3veBwLM4rXdMyr4qEKJhAKgg9QJVzcz4jhAY9Xy/DIOoGAAqSKehsmZmXGsERmjis6lzdAzAVDo3FT4uf3NKYEDhtQkCatQXO1dOxSDyLwMQLQNARdWUYGPjQe43uNzs/G2FQARa/rp6Rs0AUHm9ovDqu6S+k9JAXW/gc4OAHPXFiVgUfaZSZdfoGYCpNKUBgwSvaxFIYNQv1j8ZBmAqTd2AQYLXJQSi0/Av1a/0Z3IMACjoacGeR+Ut/QZKu0VSkdvSkez80KfyhoJwkgzAgM9pgUEi0Wti4n5ZKyfNAAwgalowzY5Kv8h9Jo7XqBFQ4n6spj2XliMDyNGitcCl24w2bTLafdsWIgNYQoqMYAmQOH6S8CvakQygApiZonAqDnJqUAFS+NEk/Jo2IgOoAWgmEVBHUINUQI+h3MvEuRQcedqiTgZgiSAZgSVQPpOR8J3RJwNwhoxrDBpA1u8rivCnL1Kr7w4zGYA7ZrM3qCeYQeHjhvP7DlAnA+gARMUIxGSf0CsPb5NZcglyB7iWZKG99tT8Ps7luSV17jWKDKBjeOe6AlgPMjKD9vhKohcfiIwifnsoV3MgA1jFpLOYOTNQXobXyIwpGdihWyD63bfHvOuuXXX9pSIDGAj7OTOgZFAJObbdonhfCU8fD8gA+kDVIs98A9M75Uq0rUSnCvkoD3v9zhmO8hadpockZAA9gOqa5UyJONm4Sc53DwqRSaYg4poywFQnppcks7sEghdi52KMe+y5tr3v9GQAvlug5PuaIeCBtCxMJlpKEJlhCngQqi4BpjlJ51Jpt0TsiCbBA4WwAhlAWO1RWZoFpoBUYAwImEKIrMgcZGRvDEITOL6AUCR0EPzO7tsY2fGIxA4Uwg9kAOG3kVUJVxgE3sKUQoVsS1/lf8UwZr9WbyCiz4IkagRF2OoOP0jgBooIrv8PYqFawe5PPnwAAAAASUVORK5CYII=",
        id: "image0_2434_171328",
        width: 256,
        height: 256
    }))));
};
/* harmony default export */ var g2 = (SvgG2);

;// CONCATENATED MODULE: ./static/svg/header/customers/Trustradius.svg
var Trustradius_path, Trustradius_path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, Trustradius_defs;
function Trustradius_extends() {
    Trustradius_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return Trustradius_extends.apply(this, arguments);
}

var SvgTrustradius = function SvgTrustradius(props) {
    return /*#__PURE__*/ react.createElement("svg", Trustradius_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 112,
        height: 19,
        fill: "none",
        viewBox: "0 0 112 19"
    }, props), Trustradius_path || (Trustradius_path = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_2434_171178)",
        d: "M8.98.056c.075.037.15.074.206.13l3.223 3.223c.13.13.205.299.205.485v14.868c0 .13-.093.224-.224.224a.2.2 0 0 1-.149-.056l-3.037-3.037A.68.68 0 0 1 9 15.41V.056z"
    })), Trustradius_path2 || (Trustradius_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint1_linear_2434_171178)",
        d: "M17.85.205a.8.8 0 0 1 .205-.15V15.41a.68.68 0 0 1-.205.484l-3.037 3.037a.214.214 0 0 1-.373-.149V3.913c0-.168.075-.354.205-.466z"
    })), _path3 || (_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint2_linear_2434_171178)",
        d: "m23.7 12.018-.223-.224V8.627h-3.075a.23.23 0 0 0-.168.074l-2.198 2.2 7.043 7.06a.66.66 0 0 0 .484.187h3.708c.13 0 .224-.093.224-.224a.2.2 0 0 0-.056-.149z"
    })), _path4 || (_path4 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint3_linear_2434_171178)",
        d: "M18.316 0a.68.68 0 0 0-.485.205l-3.223 3.223c-.056.056-.093.13-.13.187h8.999v8.16L23.7 12l3.205-3.186a.68.68 0 0 0 .205-.484V3.913a.68.68 0 0 0-.205-.485L23.682.205A.68.68 0 0 0 23.197 0z"
    })), _path5 || (_path5 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint4_linear_2434_171178)",
        d: "M9.167.205A.68.68 0 0 0 8.683 0H.223A.215.215 0 0 0 0 .224C0 .279.019.335.075.39l3.037 3.037c.13.13.298.205.484.205h8.57c.243 0 .448.205.448.447v-.167a.68.68 0 0 0-.205-.485z"
    })), _path6 || (_path6 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint5_linear_2434_171178)",
        d: "M17.831.205A.68.68 0 0 1 18.316 0h4.881c.187 0 .354.075.485.205l3.223 3.223c.13.13.205.298.205.485v.167a.453.453 0 0 0-.447-.447H14.887a.453.453 0 0 0-.447.447v-.167c0-.187.075-.354.205-.485z"
    })), _path7 || (_path7 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint6_linear_2434_171178)",
        d: "M27.11 8.161a.453.453 0 0 1-.447.447h-6.074a.12.12 0 0 0-.112.112c0 .037.019.056.037.075l3.205 3.204 3.205-3.186a.68.68 0 0 0 .205-.484V8.16z"
    })), _path8 || (_path8 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint7_linear_2434_171178)",
        d: "M111.794 12.15c0-1.528-.876-2.105-3.019-2.646-1.286-.317-1.621-.577-1.621-1.025s.41-.745 1.248-.745c.932.037 1.826.28 2.646.727l.261-1.64a7.4 7.4 0 0 0-2.907-.577c-1.937 0-3.074.987-3.074 2.366 0 1.49.839 2.05 2.851 2.553 1.397.335 1.789.559 1.789 1.155 0 .54-.541.875-1.491.875a6.1 6.1 0 0 1-3.074-.95l-.261 1.658a7.55 7.55 0 0 0 3.242.783c2.236 0 3.41-.95 3.41-2.534m-7.621 2.366v-8.16h-1.975v5.533c-.652.634-1.342 1.044-2.031 1.044-.801 0-1.137-.485-1.137-1.211V6.337h-1.975v5.888c0 1.509.839 2.422 2.441 2.422 1.118 0 2.031-.578 2.832-1.305l.28 1.137zm-8.31 0v-8.16h-1.956v8.16zm-.969-11.738a1.13 1.13 0 0 1 1.137 1.137 1.13 1.13 0 0 1-1.137 1.136 1.13 1.13 0 0 1-1.137-1.136 1.13 1.13 0 0 1 1.137-1.137m-4.118 9.018c-.577.708-1.21 1.155-2.012 1.155-.987 0-1.714-.764-1.714-2.366 0-1.789.857-2.665 2.012-2.665a3.8 3.8 0 0 1 1.714.355zm1.957 2.72V2.386l-1.957.336v3.932a6.5 6.5 0 0 0-1.993-.317c-1.975 0-3.727 1.341-3.727 4.36 0 2.72 1.435 3.987 3.224 3.987 1.192 0 2.012-.596 2.627-1.286l.167 1.118zM82.28 12.28a3.15 3.15 0 0 1-2.087.913c-.67 0-1.1-.372-1.1-.95 0-.782.616-1.472 3.206-1.77v1.807zm1.956 2.236V8.964c0-1.92-1.043-2.702-3.204-2.702a8.8 8.8 0 0 0-3.317.652l.242 1.565a7.9 7.9 0 0 1 2.851-.652c.932 0 1.49.336 1.49 1.211V9.3c-3.465.336-5.142 1.174-5.142 3.13 0 1.398.969 2.236 2.422 2.236a4 4 0 0 0 2.851-1.21l.186 1.043h1.621zm-7.415-.298-3.13-4.267c1.416-.447 2.347-1.434 2.347-3.037 0-2.086-1.509-3.279-4.006-3.279h-3.447v10.881h2.031v-4.21h.988l3.055 4.304zm-2.814-7.192c0 1.137-.857 1.752-2.236 1.752h-1.155V5.312h1.267c1.398.019 2.124.633 2.124 1.714m-6.446 7.49-.243-1.62a4.4 4.4 0 0 1-.708.055c-.8 0-1.118-.354-1.118-1.025V7.94h2.069l-.336-1.584h-1.733V3.523l-1.937.336v2.496h-1.323V7.94h1.323v4.304c0 1.826 1.08 2.385 2.701 2.385.448.019.876-.018 1.305-.112m-5.74-2.366c0-1.528-.875-2.105-3.018-2.646-1.285-.317-1.62-.577-1.62-1.025s.41-.745 1.248-.745c.931.037 1.826.28 2.646.727l.279-1.64a7.4 7.4 0 0 0-2.907-.577c-1.937 0-3.074.987-3.074 2.366 0 1.49.839 2.05 2.85 2.553 1.398.335 1.79.559 1.79 1.155 0 .54-.54.875-1.491.875a5.9 5.9 0 0 1-3.037-.95l-.28 1.658a7.6 7.6 0 0 0 3.261.783c2.18 0 3.354-.95 3.354-2.534m-7.508 2.366v-8.16h-1.975v5.533c-.652.634-1.342 1.044-2.03 1.044-.802 0-1.138-.485-1.138-1.211V6.337h-1.974v5.888c0 1.509.838 2.422 2.44 2.422 1.118 0 2.031-.578 2.832-1.305l.28 1.137zm-8.05-6.353-.446-1.92c-1.249.224-1.994.876-2.572 1.808l-.372-1.696H41.4v8.161h1.919V9.858a3.83 3.83 0 0 1 2.944-1.695"
    })), _path9 || (_path9 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint8_linear_2434_171178)",
        d: "m42.63 5.44-.446-1.807H32.55V5.44h3.633v9.074h2.031V5.44z"
    })), Trustradius_defs || (Trustradius_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_2434_171178",
        x1: 10.804,
        x2: 10.804,
        y1: 18.99,
        y2: 0.052,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.71,
        stopColor: "#116BF2"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#1E50E5"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint1_linear_2434_171178",
        x1: 16.247,
        x2: 16.247,
        y1: 18.994,
        y2: 0.056,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.71,
        stopColor: "#116BF2"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#1E50E5"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint2_linear_2434_171178",
        x1: 19.739,
        x2: 28.604,
        y1: 8.983,
        y2: 17.847,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.41,
        stopColor: "#116BF2"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#185DEC"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint3_linear_2434_171178",
        x1: 20.755,
        x2: 20.755,
        y1: 11.999,
        y2: -0.112,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.58,
        stopColor: "#116BF2"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#1E50E5"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint4_linear_2434_171178",
        x1: 8.445,
        x2: 4.837,
        y1: -0.19,
        y2: 3.418,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.03,
        stopColor: "#59C5FF"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.99,
        stopColor: "#21B1FF"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint5_linear_2434_171178",
        x1: 17.512,
        x2: 21.12,
        y1: 0.759,
        y2: 4.367,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.04,
        stopColor: "#59C5FF"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.99,
        stopColor: "#21B1FF"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint6_linear_2434_171178",
        x1: 25.606,
        x2: 22.879,
        y1: 10.271,
        y2: 7.544,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.04,
        stopColor: "#57C4FF"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.99,
        stopColor: "#21B1FF"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint7_linear_2434_171178",
        x1: 41.401,
        x2: 111.794,
        y1: 8.535,
        y2: 8.535,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.71,
        stopColor: "#116BF2"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#1E50E5"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint8_linear_2434_171178",
        x1: 32.551,
        x2: 42.631,
        y1: 9.073,
        y2: 9.073,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.71,
        stopColor: "#116BF2"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#1E50E5"
    })))));
};
/* harmony default export */ var Trustradius = (SvgTrustradius);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-bottom-part/structured-header-menu-bottom-part-components/social-proof-component.scss.js


var StyledSocialProofComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18amlmu0"
})("display:flex;align-items:center;font-size:0.75rem;font-weight:400;color:", colors/* default.asphalt */.Z.asphalt, ";gap:8px;.stars{display:flex;}.logo-wrapper{height:19px;display:flex;align-items:center;}.reviews-text{white-space:nowrap;}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-bottom-part/structured-header-menu-bottom-part-components/social-proof-component.js







var SocialProofComponent = function(param) {
    var translate = param.translate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSocialProofComponent, {
        className: "social-proof-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "stars",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(filled_star, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(filled_star, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(filled_star, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(filled_star, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partially_filled_star, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "reviews-text",
                children: translate("header.tabs.customers.section.bottomPart.socialProofText")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "logo-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(g2, {
                    height: "19",
                    width: "19"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "logo-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trustradius, {
                    height: "15",
                    width: "auto"
                })
            })
        ]
    });
};
/* harmony default export */ var social_proof_component = ((0,generic_config_context/* withGenericConfig */.P)(SocialProofComponent));

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-bottom-part/structured-header-menu-bottom-part-components/bottom-items-component.scss.js



var StyledBottomItemsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eg0qsbv0"
})("display:flex;width:375px;justify-content:center;.bottom-items{display:flex;align-items:center;.separator{width:1px;height:50%;background:", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR_NAME], ";}.header-menu-section-item-component-wrapper{width:auto;height:auto;padding:0 16px;margin:0 8px;.header-menu-section-item-component{font-size:0.8125rem;color:", colors/* default.asphalt */.Z.asphalt, ";display:flex;align-items:center;gap:8px;height:24px;.header-menu-item-content{align-items:center;.menu-item-title-icon{margin-right:8px;height:14px;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-bottom-part/structured-header-menu-bottom-part-components/bottom-items-component.js
function bottom_items_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function bottom_items_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            bottom_items_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function bottom_items_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function bottom_items_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        bottom_items_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var BottomItemsComponent = function(props) {
    var items = props.items, menuId = props.menuId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBottomItemsComponent, {
        className: "bottom-items-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bottom-items",
            children: items.map(function(bottomItem, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        index !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "separator"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu_section_item_component, bottom_items_component_object_spread_props(bottom_items_component_object_spread({}, bottomItem), {
                            menuId: menuId
                        }))
                    ]
                });
            })
        })
    });
};
/* harmony default export */ var bottom_items_component = (BottomItemsComponent);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-bottom-part/structured-header-menu-bottom-part.js





var StructuredHeaderMenuBottomPartComponent = function(props) {
    var menuId = props.menuId, panel = props.panel;
    var items = panel.bottomItems, isSocialProofDisplayed = panel.isSocialProofDisplayed;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStructuredHeaderMenuBottomPartComponent, {
        className: "structured-header-menu-bottom-part-component",
        children: [
            isSocialProofDisplayed && /*#__PURE__*/ (0,jsx_runtime.jsx)(social_proof_component, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "spacer"
            }),
            items && /*#__PURE__*/ (0,jsx_runtime.jsx)(bottom_items_component, {
                menuId: menuId,
                items: items
            })
        ]
    });
};
/* harmony default export */ var structured_header_menu_bottom_part = ((0,generic_config_context/* withGenericConfig */.P)(StructuredHeaderMenuBottomPartComponent));

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/structured-header-menu/structured-header-menu-component.js







var DEAFULT_INNER_MENU_INDEX = 0;
var DEAFULT_INNER_MENU_SUB_INDEX = 0;
var StructuredHeaderMenuComponent = function(props) {
    var ref = (0,react.useState)(DEAFULT_INNER_MENU_INDEX), innerMenuIndex = ref[0], setInnerMenuIndex = ref[1];
    var ref1 = (0,react.useState)(DEAFULT_INNER_MENU_SUB_INDEX), innerMenuSubIndex = ref1[0], setInnerMenuSubIndex = ref1[1];
    var ref2 = (0,react.useState)([
        true,
        true
    ]), itemsCollapsedState = ref2[0], setItemsCollapsedState = ref2[1];
    var menuItems = props.menuItems, menuId = props.menuId, enhancedProducts = props.enhancedProducts;
    var content = menuItems.content, innerMenu = menuItems.innerMenu;
    var onItemClick = function(menuIndex) {
        setInnerMenuIndex(menuIndex);
    // Temp. preventing collapsing until clear test results
    // setItemsCollapsedState(itemsCollapsedState.map((isCollapsed, index) => index === menuIndex ? !isCollapsed : false ))
    };
    var hasSubItems = function(itemIndex) {
        return innerMenu.items[itemIndex] && innerMenu.items[itemIndex].subItems;
    };
    var getContent = function() {
        if (!innerMenu) {
            return content;
        }
        var items = innerMenu.items;
        // inner content will be displayed if exists
        if (items) {
            var currentItem = items[innerMenuIndex];
            if (hasSubItems(innerMenuIndex)) {
                var currentSubItem = currentItem.subItems[innerMenuSubIndex];
                return currentSubItem.content;
            }
            return currentItem.content;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStructuredHeaderMenuComponent, {
        className: classnames_default()("structured-header-menu-component", menuId, {
            "with-left-panel": innerMenu
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "structured-header-menu",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "structured-header-menu-top-part",
                    children: [
                        innerMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(structured_header_menu_left_panel, {
                            menu: innerMenu,
                            hasSubItems: hasSubItems,
                            innerMenuIndex: innerMenuIndex,
                            innerMenuSubIndex: innerMenuSubIndex,
                            itemsCollapsedState: itemsCollapsedState,
                            onItemClick: onItemClick,
                            setInnerMenuIndex: setInnerMenuIndex,
                            setInnerMenuSubIndex: setInnerMenuSubIndex,
                            menuId: menuId,
                            enhancedProducts: enhancedProducts
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(structured_header_menu_content, {
                            menuId: menuId,
                            content: getContent()
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "structured-header-menu-bottom-part",
                    children: menuItems.bottomPanel && /*#__PURE__*/ (0,jsx_runtime.jsx)(structured_header_menu_bottom_part, {
                        menuId: menuId,
                        panel: menuItems.bottomPanel
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var structured_header_menu_component = (StructuredHeaderMenuComponent);

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/index.js



/* harmony default export */ var header_menu = ({
    BaseHeaderMenuComponent: BaseHeaderMenuComponent,
    SectionsHeaderMenuComponent: sections_header_menu_component,
    StructuredHeaderMenuComponent: structured_header_menu_component
});

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/structured-header/structured-header.scss.js



var StyledStructuredHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("nav", {
    target: "e15gf1e10"
})(".products-switcher-open-button{cursor:pointer;margin-left:16px;border-radius:4px;.picture-component{display:flex;height:40px;width:40px;}&.show-switcher{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";}:hover{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/structured-header/const.js
var PRODUCTS_SWITCHER_LOGO = "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/switcher-icon-hp.png";
var PRODUCTS_SWITCHER_LOGO_DARK = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/Switcher.png";

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/structured-header/structured-header.js
function structured_header_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function structured_header_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            structured_header_define_property(target, key, source[key]);
        });
    }
    return target;
}
function structured_header_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function structured_header_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        structured_header_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
































var StructuredHeader = function(props) {
    var showMenu = props.showMenu, showButton = props.showButton, buttonConfig = props.buttonConfig, hideLanguagePicker = props.hideLanguagePicker, shouldShowMainPricingLink = props.shouldShowMainPricingLink, isSecondaryMenuNeeded = props.isSecondaryMenuNeeded, renderUnifiedLinks = props.renderUnifiedLinks, hideLogin = props.hideLogin, abTests = props.abTests, testTypeformContactSales = props.testTypeformContactSales, forceTypeformContactSalesExperience = props.forceTypeformContactSalesExperience, cloudfrontViewerCountry = props.cloudfrontViewerCountry, openedMenuId = props.openedMenuId, openLinkMenu = props.openLinkMenu, closeLinkMenu = props.closeLinkMenu, isExistingAccountHeader = props.isExistingAccountHeader, simulateContactSalesProminantButtonExistingUsersTest = props.simulateContactSalesProminantButtonExistingUsersTest, simulateTalkToSalesInWebsiteHeaderTest = props.simulateTalkToSalesInWebsiteHeaderTest, isTypeformDisabled = props.isTypeformDisabled, translate = props.translate, persistantCookies = props.persistantCookies, pageProductId = props.pageProductId, showSuccessStoriesInHeader = props.showSuccessStoriesInHeader, shouldRemoveSalesCrm = props.shouldRemoveSalesCrm, shouldHaveEnhancedProducts = props.shouldHaveEnhancedProducts, setShowproductsSwithcer = props.setShowproductsSwithcer, showproductsSwithcer = props.showproductsSwithcer, isInContactSalesNoHeaderTest = props.isInContactSalesNoHeaderTest, isDynamicColor = props.isDynamicColor, removeContactSalesButton = props.removeContactSalesButton;
    var openSolutionsMenu = function() {
        return openLinkMenu(base_header_service/* SOLUTIONS_MENU_ID */.e1);
    };
    var openTeamsMenu = function() {
        return openLinkMenu(base_header_service/* TEAMS_MENU_ID */.$Q);
    };
    var openPlatformMenu = function() {
        return openLinkMenu(base_header_service/* PLATFORM_MENU_ID */.wP);
    };
    var openCustomersMenu = function() {
        return openLinkMenu(base_header_service/* CUSTOMERS_MENU_ID */.xN);
    };
    var openResourcesMenu = function() {
        return openLinkMenu(base_header_service/* RESOURCES_MENU_ID */.Gu);
    };
    var isMenuOpen = function(menuId) {
        return openedMenuId === menuId;
    };
    var shouldGetProductsSwitcherExperience = !isExistingAccountHeader && !(0,existing_accounts_service/* isExistingUserInHeaderTest */.Cl)(persistantCookies) && showMenu;
    var showContactSalesProminantButtonForExisting = function() {
        if (!(0,existing_accounts_service/* isExistingUserInHeaderTest */.Cl)(persistantCookies)) return false;
        return simulateContactSalesProminantButtonExistingUsersTest || (0,existing_accounts_service/* isExistingUserContactSalesInHeaderTest */.gk)(persistantCookies, true);
    };
    var talkToSalesCopy = function() {
        if (!showMenu || (0,existing_accounts_service/* isExistingUserInHeaderTest */.Cl)(persistantCookies)) return false;
        return simulateTalkToSalesInWebsiteHeaderTest || (0,acquisition_ab_test_service.shouldGetTalkToSalesInWebsiteHeader)(abTests, true);
    };
    var shouldGetProminantContactSalesTest = !isInContactSalesNoHeaderTest && (!(0,existing_accounts_service/* isExistingUserInHeaderTest */.Cl)(persistantCookies) || showContactSalesProminantButtonForExisting());
    var getContactSalesButtonText = function() {
        if (talkToSalesCopy()) {
            return translate("pricingPage.plans.enterprise.cta.talkToSales");
        }
        return translate("header.contactSales");
    };
    var getContactSalesUrl = function() {
        if ((0,new_ab_tests_service.isInTest)(new_ab_tests.CONTACT_SALES_STICKY_BUTTON_EXPERIENCE, abTests)) {
            if ((0,acquisition_ab_test_service.shouldGetContactSalesStickyButtonExperience)(abTests, false)) {
                return links/* CONTACT_SALES_FROM_STICKY_BUTTON_TEST_LINK */.YJQ;
            }
            return links/* CONTACT_SALES_FROM_STICKY_BUTTON_CONTROL_LINK */.CSM;
        }
        return links/* CONTACT_US_FROM_HEADER_PAGE_LINK */.lij;
    };
    var renderContactSalesButton = function() {
        var buttonURLProp = {
            url: getContactSalesUrl()
        };
        if ((0,typeform_service/* shouldGetTypeformExperience */.ap)({
            abTests: abTests,
            isTypeformDisabled: isTypeformDisabled,
            cloudfrontViewerCountry: cloudfrontViewerCountry,
            testTypeformContactSales: testTypeformContactSales,
            forceTypeformContactSalesExperience: forceTypeformContactSalesExperience
        })) {
            buttonURLProp = {};
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "link-item-component-wrapper",
            role: "listitem",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_component/* default */.Z, structured_header_object_spread({
                title: "header.contactSales",
                clickEvent: onContactSalesClicked
            }, buttonURLProp))
        });
    };
    var renderSubmenuWithTransitionIfNeeded = function(menuId) {
        // always render transition - menu rendered only if open
        var isMenuOpen = openedMenuId === menuId;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: isMenuOpen && renderMainHeaderPopup(menuId)
        });
    };
    var renderMainHeaderPopup = function(menuId) {
        var enhancedProducts = menuId === base_header_service/* SOLUTIONS_MENU_ID */.e1 && (shouldHaveEnhancedProducts || (0,acquisition_ab_test_service.shouldHaveEnhancedProductsInHeaderTest)(abTests, true));
        var headerMenuItems = menuId === base_header_service/* SOLUTIONS_MENU_ID */.e1 && (shouldRemoveSalesCrm || (0,acquisition_ab_test_service.shouldGetCrmRemoveSalesTest)(abTests, true)) ? base_header_service/* solutionsMenuCrmRemoveSales */.Sf : base_header_service/* StructuredHeaderMenuMapping */.M2[menuId];
        var MenuComponent = header_menu[base_header_service/* StructuredHeaderMenuComponentMapping */.jm[menuId]];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()(base_header_constants/* default.HEADER_MENU_COMPONENT_WRAPPER_CLASS_NAME */.Z.HEADER_MENU_COMPONENT_WRAPPER_CLASS_NAME, {
                "enhanced-products": enhancedProducts
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                "aria-label": "main submenu",
                className: "menu-component-wrapper",
                children: MenuComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuComponent, {
                    menuItems: headerMenuItems,
                    menuId: menuId,
                    enhancedProducts: enhancedProducts
                })
            })
        }, menuId);
    };
    var showSuccessStories = showSuccessStoriesInHeader || (0,acquisition_ab_test_service.shouldShowSuccessStoriesInHeaderTest)(abTests, true);
    var renderBaseHeaderLeftLinks = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(base_header_service/* SOLUTIONS_MENU_ID */.e1)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_with_menu_component, {
                        title: "header.products",
                        openMenu: openSolutionsMenu,
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(base_header_service/* SOLUTIONS_MENU_ID */.e1)
                    })
                }),
                renderSubmenuWithTransitionIfNeeded(base_header_service/* SOLUTIONS_MENU_ID */.e1),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(base_header_service/* TEAMS_MENU_ID */.$Q)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_with_menu_component, {
                        title: "header.teams",
                        openMenu: openTeamsMenu,
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(base_header_service/* TEAMS_MENU_ID */.$Q)
                    })
                }),
                renderSubmenuWithTransitionIfNeeded(base_header_service/* TEAMS_MENU_ID */.$Q),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(base_header_service/* PLATFORM_MENU_ID */.wP)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_with_menu_component, {
                        title: "header.platform",
                        openMenu: openPlatformMenu,
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(base_header_service/* PLATFORM_MENU_ID */.wP)
                    })
                }),
                renderSubmenuWithTransitionIfNeeded(base_header_service/* PLATFORM_MENU_ID */.wP),
                showSuccessStories && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(base_header_service/* CUSTOMERS_MENU_ID */.xN)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_with_menu_component, {
                        title: "header.successStories",
                        openMenu: openCustomersMenu,
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(base_header_service/* CUSTOMERS_MENU_ID */.xN)
                    })
                }),
                showSuccessStories && renderSubmenuWithTransitionIfNeeded(base_header_service/* CUSTOMERS_MENU_ID */.xN),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("link-item-with-menu-component-wrapper", {
                        "is-open": isMenuOpen(base_header_service/* RESOURCES_MENU_ID */.Gu)
                    }),
                    role: "listitem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_with_menu_component, {
                        title: "header.resources",
                        openMenu: openResourcesMenu,
                        closeMenu: closeLinkMenu,
                        isOpen: isMenuOpen(base_header_service/* RESOURCES_MENU_ID */.Gu)
                    })
                }),
                renderSubmenuWithTransitionIfNeeded(base_header_service/* RESOURCES_MENU_ID */.Gu)
            ]
        });
    };
    var displayTypeform = (0,use_contact_cales_typeform/* useContactSalesTypeform */.O)({
        abTests: abTests,
        fallbackLink: links/* CONTACT_US_FROM_HEADER_PAGE_LINK */.lij
    }).displayTypeform;
    var onContactSalesClicked = (0,react.useCallback)(function() {
        !isTypeformDisabled && displayTypeform();
    }, [
        displayTypeform,
        isTypeformDisabled
    ]);
    var fireEvent = function() {
        (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).SIGNUP_CLICKED, {
            click_text: translate("existingAccount.createAccountCta"),
            click_location: "header"
        });
    };
    var prominantContactSalesClicked = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.CONTACT_SALES_PROMINANT_BUTTON_CLICKED);
    };
    var buildHeaderStructure = function() {
        // init header according to its props
        var headerStructure = {
            leftLinks: {
                isVisible: showMenu
            },
            languagePicker: {
                isVisible: !showMenu && showButton && !hideLanguagePicker
            },
            pricing: {
                isVisible: showMenu && shouldShowMainPricingLink()
            },
            contactSales: {
                isVisible: showButton && (buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.buttonType) === button_consts/* SIGNUP_BUTTON_TYPE */.ge && !shouldGetProminantContactSalesTest
            },
            login: {
                isVisible: showMenu && !hideLogin
            },
            createNewAccountButton: {
                isVisible: false
            },
            button: {
                isVisible: showButton
            }
        };
        if ((buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.buttonType) === button_consts/* SIGNUP_BUTTON_TYPE */.ge && showButton && (isExistingAccountHeader || (0,existing_accounts_service/* isExistingUserInHeaderTest */.Cl)(persistantCookies))) {
            headerStructure.login.isVisible = false;
            headerStructure.createNewAccountButton.isVisible = !shouldGetProminantContactSalesTest;
            headerStructure.button.extraProps = {
                forceGoToMyAccount: true
            };
        }
        return headerStructure;
    };
    var showSwitcher = function() {
        if (!showproductsSwithcer) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SWITCHER_OPENED);
        }
        setShowproductsSwithcer(!showproductsSwithcer);
    };
    var ref = buildHeaderStructure(), leftLinks = ref.leftLinks, languagePicker = ref.languagePicker, pricing = ref.pricing, contactSales = ref.contactSales, login = ref.login, button = ref.button, createNewAccountButton = ref.createNewAccountButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStructuredHeader, {
        "aria-label": "Main",
        className: classnames_default()("base-header-desktop-content"),
        children: [
            leftLinks.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "left-side-header-links",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute-main-links",
                        role: "list",
                        children: renderBaseHeaderLeftLinks()
                    }),
                    isSecondaryMenuNeeded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute-unified-links",
                        children: renderUnifiedLinks()
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "right-side-header-links",
                role: "list",
                children: [
                    languagePicker.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("link-item-component-wrapper", "header-language-picker"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(language_picker_component/* default */.Z, {
                            dialogDirection: language_picker_service/* DIALOG_DIRECTIONS.ALIGN_BOTTOM */.Df.ALIGN_BOTTOM,
                            showLabel: false,
                            showMainLanguagesOnly: true
                        })
                    }),
                    pricing.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "link-item-component-wrapper",
                        role: "listitem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_component/* default */.Z, {
                            title: "header.pricing",
                            url: links/* PRICING_PAGE_LINK */.C9V
                        })
                    }),
                    contactSales.isVisible && !shouldGetProminantContactSalesTest && !removeContactSalesButton && renderContactSalesButton(),
                    login.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "link-item-component-wrapper",
                        role: "listitem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_component/* default */.Z, {
                            title: "header.logIn",
                            url: links/* LOGIN_PAGE_LINK */.dVh
                        })
                    })
                ]
            }),
            createNewAccountButton.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header-create-account-button-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(regular_button/* default */.Z, {
                    onClick: fireEvent,
                    buttonText: translate("existingAccount.createAccountCta"),
                    color: isDynamicColor ? color_consts.WHITE_COLOR_NAME : color_consts.WORK_OS_IRIS_COLOR_NAME,
                    outline: true,
                    url: (0,existing_accounts_service/* getSignupLink */.hD)(pageProductId),
                    isWithArrow: false,
                    buttonSize: sizes.SM,
                    extraEventData: {
                        englishText: (0,localization_service/* translateToEnglish */.lS)("existingAccount.createAccountCta")
                    }
                })
            }),
            shouldGetProminantContactSalesTest && !removeContactSalesButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header-prominant-contact-sales-button-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(regular_button/* default */.Z, {
                    buttonText: getContactSalesButtonText(),
                    color: isDynamicColor ? color_consts.WHITE_COLOR_NAME : color_consts.WORK_OS_IRIS_COLOR_NAME,
                    outline: true,
                    url: getContactSalesUrl(),
                    isWithArrow: false,
                    buttonSize: sizes.SM,
                    onClick: prominantContactSalesClicked,
                    extraEventData: {
                        englishText: (0,localization_service/* translateToEnglish */.lS)("header.contactSales")
                    }
                })
            }),
            button.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header-button-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, structured_header_object_spread(structured_header_object_spread_props(structured_header_object_spread({}, buttonConfig), {
                    parentSegment: base_header_constants/* default.DESKTOP_HEADER_SEGMENT_NAME */.Z.DESKTOP_HEADER_SEGMENT_NAME
                }), button.extraProps))
            }),
            shouldGetProductsSwitcherExperience && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("products-switcher-open-button", {
                    "show-switcher": showproductsSwithcer
                }),
                onClick: function() {
                    return showSwitcher();
                },
                onMouseEnter: function() {
                    return (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SWITCHER_LOGO_HOVERED);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    src: isDynamicColor && !showproductsSwithcer ? PRODUCTS_SWITCHER_LOGO_DARK : PRODUCTS_SWITCHER_LOGO
                })
            })
        ]
    });
};
/* harmony default export */ var structured_header = ((0,generic_config_context/* withGenericConfig */.P)((0,ab_tests_context/* withAbTests */.k)(StructuredHeader)));

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-desktop/base-header-desktop-component.js
function base_header_desktop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function base_header_desktop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            base_header_desktop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}



















var BaseHeaderDesktopComponent = function(props) {
    var ref = (0,react.useState)(null), openedMenuId = ref[0], setOpenedMenuId = ref[1];
    var ref1 = (0,react.useState)(null), showproductsSwithcer = ref1[0], setShowproductsSwithcer = ref1[1];
    var ref2 = (0,react.useState)(props === null || props === void 0 ? void 0 : props.shouldUseDynamicColor), isDynamicColor = ref2[0], setIsDynamicColor = ref2[1];
    var _scrollInfo = {
        scrollTopWhenStartedScrollingUp: 0,
        prevScrollTop: 0,
        scrollingDown: true
    };
    var _basicHeader = (0,react.useRef)(null);
    var _headerRef = (0,react.useRef)(null);
    var isSecondaryMenuNeeded = props.isSecondaryMenuNeeded, buttonConfig = props.buttonConfig, pageClusterConfig = props.pageClusterConfig, useProductMiniSiteConfig = props.useProductMiniSiteConfig, showMenu = props.showMenu, hideLogin = props.hideLogin, showButton = props.showButton, logoHref = props.logoHref, logoSrc = props.logoSrc, logoPopup = props.logoPopup, isExistingAccountHeader = props.isExistingAccountHeader, simulateContactSalesProminantButtonExistingUsersTest = props.simulateContactSalesProminantButtonExistingUsersTest, simulateContactSalesWebsitePagesNewUsersTest = props.simulateContactSalesWebsitePagesNewUsersTest, hideLanguagePicker = props.hideLanguagePicker, abTests = props.abTests, overrideClusterLogo = props.overrideClusterLogo, testTypeformContactSales = props.testTypeformContactSales, forceTypeformContactSalesExperience = props.forceTypeformContactSalesExperience, showSuccessStoriesInHeader = props.showSuccessStoriesInHeader, shouldRemoveSalesCrm = props.shouldRemoveSalesCrm, shouldHaveEnhancedProducts = props.shouldHaveEnhancedProducts, trackScroll = props.trackScroll, shouldUseDynamicColor = props.shouldUseDynamicColor, removeContactSalesButton = props.removeContactSalesButton;
    (0,react.useEffect)(function() {
        if (!openedMenuId) {
            removeClickOutsideEvent();
            return;
        }
        window.addEventListener("mousedown", handleClickOutsideMenu);
        return function() {
            removeClickOutsideEvent();
        };
    }, [
        openedMenuId
    ]);
    (0,react.useEffect)(function() {
        if (isSecondaryMenuNeeded) {
            window.addEventListener("scroll", scrollListenerForSecondaryMenuUnification, {
                passive: true
            });
            return function() {
                window.removeEventListener("scroll", scrollListenerForSecondaryMenuUnification);
                removeClickOutsideEvent();
            };
        }
    }, []);
    var removeClickOutsideEvent = function() {
        window.removeEventListener("mousedown", handleClickOutsideMenu);
    };
    var handleClickOutsideMenu = function(event) {
        if ((_headerRef === null || _headerRef === void 0 ? void 0 : _headerRef.current) && !_headerRef.current.contains(event.target)) {
            closeLinkMenu();
        }
    };
    var scrollListenerForSecondaryMenuUnification = function(event) {
        {
            var header = document.querySelector(".".concat(base_header_service/* DESKTOP_HEADER_BASE_CLASS_NAME */.Nl));
            if (!header) {
                return;
            }
            var scrolledUpEnough = false;
            if (document.scrollingElement.scrollTop > _scrollInfo.prevScrollTop) {
                // scrolling down
                _scrollInfo.scrollingDown = true;
            } else {
                // scrolling up
                if (_scrollInfo.scrollingDown) {
                    _scrollInfo.scrollTopWhenStartedScrollingUp = document.scrollingElement.scrollTop;
                }
                scrolledUpEnough = _scrollInfo.scrollTopWhenStartedScrollingUp - document.scrollingElement.scrollTop > base_header_constants/* default.SCROLL_BACK_UP_THRESHOLD */.Z.SCROLL_BACK_UP_THRESHOLD;
                _scrollInfo.scrollingDown = false;
            }
            _scrollInfo.prevScrollTop = document.scrollingElement.scrollTop;
            var showUnifiedBanner = document.scrollingElement.scrollTop > base_header_constants/* default.SCROLL_PIXEL_THRESHOLD */.Z.SCROLL_PIXEL_THRESHOLD && (_scrollInfo.scrollingDown || !scrolledUpEnough);
            if (document.scrollingElement.scrollTop > 0) {
                // shows the bottom menu border after scroll start
                header.classList.add("scroll-started");
            } else {
                header.classList.remove("scroll-started");
            }
            if (showUnifiedBanner) {
                header.classList.add("scrolled-threshold");
            } else {
                header.classList.remove("scrolled-threshold");
            }
        }
    };
    var openLinkMenu = function(menuId) {
        var _basicHeader_current;
        if (menuId === base_header_service/* SOLUTIONS_MENU_ID */.e1) {
            (0,acquisition_ab_test_service.shouldGetCrmRemoveSalesTest)(abTests, true);
        }
        setOpenedMenuId(menuId);
        var _MENU_ID_TO_EVENT_KIND_MAP_menuId;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SUBMENU_OPENED, {
            kind: (_MENU_ID_TO_EVENT_KIND_MAP_menuId = MENU_ID_TO_EVENT_KIND_MAP[menuId]) !== null && _MENU_ID_TO_EVENT_KIND_MAP_menuId !== void 0 ? _MENU_ID_TO_EVENT_KIND_MAP_menuId : menuId
        });
        _basicHeader === null || _basicHeader === void 0 ? void 0 : (_basicHeader_current = _basicHeader.current) === null || _basicHeader_current === void 0 ? void 0 : _basicHeader_current.forceShadow();
    };
    var closeLinkMenu = function(e) {
        var _basicHeader_current;
        if (!openedMenuId) return;
        setOpenedMenuId(null);
        var _MENU_ID_TO_EVENT_KIND_MAP_openedMenuId;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HEADER_SUBMENU_CLOSED, {
            kind: (_MENU_ID_TO_EVENT_KIND_MAP_openedMenuId = MENU_ID_TO_EVENT_KIND_MAP[openedMenuId]) !== null && _MENU_ID_TO_EVENT_KIND_MAP_openedMenuId !== void 0 ? _MENU_ID_TO_EVENT_KIND_MAP_openedMenuId : openedMenuId
        });
        _basicHeader === null || _basicHeader === void 0 ? void 0 : (_basicHeader_current = _basicHeader.current) === null || _basicHeader_current === void 0 ? void 0 : _basicHeader_current.unforceShadow();
    };
    var getButtonConfig = function() {
        var buttonType = buttonConfig.buttonType;
        var extraConfigs;
        switch(buttonType){
            case button_consts/* SIGNUP_BUTTON_TYPE */.ge:
                {
                    extraConfigs = {
                        buttonSize: "xs"
                    };
                    break;
                }
            default:
                {
                    extraConfigs = {};
                    break;
                }
        }
        return base_header_desktop_component_object_spread({}, buttonConfig, extraConfigs);
    };
    var getUnifiedDesktopLogoIfExists = function() {
        if (!isSecondaryMenuNeeded) return null;
        return (0,cluster_config_service/* getMiniSiteUnifiedDesktopLogo */.LN)(pageClusterConfig, {
            useProductMiniSiteConfig: useProductMiniSiteConfig
        });
    };
    var shouldShowMainPricingLink = function() {
        if (!isSecondaryMenuNeeded) return true;
        return !(0,cluster_config_service/* shouldHideGeneralPricingInMinisite */.Wi)(pageClusterConfig, {
            useProductMiniSiteConfig: useProductMiniSiteConfig
        });
    };
    var renderUnifiedLinks = function() {
        var links = (0,cluster_config_service/* getMiniSiteLinks */.J9)(pageClusterConfig, {
            onlyUnifiedLinks: true,
            useProductMiniSiteConfig: useProductMiniSiteConfig
        });
        return links.map(function(link) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "link-item-component-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_item_component/* default */.Z, {
                    title: link === null || link === void 0 ? void 0 : link.text,
                    url: link === null || link === void 0 ? void 0 : link.url
                })
            }, link === null || link === void 0 ? void 0 : link.text);
        });
    };
    var renderBaseHeader = function() {
        var baseHeaderProps = {
            showMenu: showMenu,
            hideLogin: hideLogin,
            showButton: showButton,
            buttonConfig: getButtonConfig(),
            openedMenuId: openedMenuId,
            openLinkMenu: openLinkMenu,
            closeLinkMenu: closeLinkMenu,
            shouldShowMainPricingLink: shouldShowMainPricingLink,
            isSecondaryMenuNeeded: isSecondaryMenuNeeded,
            renderUnifiedLinks: renderUnifiedLinks,
            isExistingAccountHeader: isExistingAccountHeader,
            simulateContactSalesProminantButtonExistingUsersTest: simulateContactSalesProminantButtonExistingUsersTest,
            simulateContactSalesWebsitePagesNewUsersTest: simulateContactSalesWebsitePagesNewUsersTest,
            hideLanguagePicker: hideLanguagePicker,
            testTypeformContactSales: testTypeformContactSales,
            forceTypeformContactSalesExperience: forceTypeformContactSalesExperience,
            showSuccessStoriesInHeader: showSuccessStoriesInHeader,
            shouldRemoveSalesCrm: shouldRemoveSalesCrm,
            shouldHaveEnhancedProducts: shouldHaveEnhancedProducts,
            setShowproductsSwithcer: setShowproductsSwithcer,
            showproductsSwithcer: showproductsSwithcer,
            isDynamicColor: isDynamicColor,
            removeContactSalesButton: removeContactSalesButton
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(structured_header, base_header_desktop_component_object_spread({}, baseHeaderProps));
    };
    var getMainPageLogo = function() {
        if (pageClusterConfig && !isSecondaryMenuNeeded) {
            var clusterMainLogo = (0,cluster_config_service/* getClusterDesktopLogo */.k7)(pageClusterConfig, {
                useProductMiniSiteConfig: useProductMiniSiteConfig
            });
            if (clusterMainLogo) {
                return {
                    logoHref: (overrideClusterLogo === null || overrideClusterLogo === void 0 ? void 0 : overrideClusterLogo.url) || clusterMainLogo.url,
                    logoSrc: (overrideClusterLogo === null || overrideClusterLogo === void 0 ? void 0 : overrideClusterLogo.src) || clusterMainLogo.src,
                    logoAltText: (overrideClusterLogo === null || overrideClusterLogo === void 0 ? void 0 : overrideClusterLogo.alt) || clusterMainLogo.alt
                };
            }
        }
        return {
            logoHref: logoHref,
            logoSrc: logoSrc
        };
    };
    var unifiedDesktopLogo = getUnifiedDesktopLogoIfExists();
    var mainLogo = getMainPageLogo();
    var onDynamicColorChange = function(newIsDynamicColor) {
        setIsDynamicColor(newIsDynamicColor);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBaseHeaderDesktopComponent, {
        className: classnames_default()(base_header_service/* DESKTOP_HEADER_BASE_CLASS_NAME */.Nl),
        ref: _headerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(basic_header_component/* default */.Z, {
                ref: _basicHeader,
                imageHref: mainLogo.logoHref,
                imageSrc: mainLogo.logoSrc,
                imageAlt: mainLogo.logoAltText,
                secondaryLogoObject: unifiedDesktopLogo,
                logoPopup: logoPopup,
                isMenuOpen: !!openedMenuId,
                trackScroll: trackScroll,
                shouldUseDynamicColor: shouldUseDynamicColor,
                onDynamicColorChange: onDynamicColorChange,
                children: renderBaseHeader()
            }),
            isSecondaryMenuNeeded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "secondary-header-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_header_desktop_component, {})
            }),
            showproductsSwithcer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "products-switcher-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(products_switcher, {
                    setShowproductsSwithcer: setShowproductsSwithcer,
                    showproductsSwithcer: showproductsSwithcer
                })
            })
        ]
    });
};
BaseHeaderDesktopComponent.defaultProps = {
    showMenu: true,
    showButton: true
};
/* harmony default export */ var base_header_desktop_component = ((0,generic_config_context/* withGenericConfig */.P)((0,ab_tests_context/* withAbTests */.k)(BaseHeaderDesktopComponent)));

// EXTERNAL MODULE: ./node_modules/@typeform/embed/build/css/popup.css
var popup = __webpack_require__(56051);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/header-menu/download-mobile-app/download-mobile-app-component.js + 1 modules
var download_mobile_app_component = __webpack_require__(78407);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/header-menu/link/link-component.js + 1 modules
var link_component = __webpack_require__(51467);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/header-menu/constants.js
var header_menu_constants = __webpack_require__(3165);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/header-menu/link-with-menu/link-with-menu-component.scss.js



var BORDER_BOTTOM = "1px solid ".concat(colors/* default.dark-marble */.Z["dark-marble"]);
var MENU_ITEM_TITLE_HEIGHT = "".concat(header_menu_constants/* default.MENU_ITEM_TITLE_HEIGHT */.Z.MENU_ITEM_TITLE_HEIGHT, "px");
var MENU_ITEM_LINK_HEIGHT = "".concat(header_menu_constants/* default.MENU_ITEM_LINK_HEIGHT */.Z.MENU_ITEM_LINK_HEIGHT, "px");
var SECTION_BORDER_BOTTOM = "1px solid ".concat(colors/* default.riverstone */.Z.riverstone);
var StyledLinkWithSectionsMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1t3h1kc0"
})("border-bottom:", BORDER_BOTTOM, ";overflow:hidden;transition:height 400ms ease;flex-shrink:0;&.is-open{.link-with-menu-title-wrapper{.link-with-menu-title-text{color:", colors/* default.iris */.Z.iris, ";}.link-with-menu-title-icon{transform:rotate(180deg);path{fill:", colors/* default.iris */.Z.iris, ";}}}}.link-with-menu-title-wrapper{display:flex;align-items:center;font-size:1.125rem;height:", MENU_ITEM_TITLE_HEIGHT, ";cursor:pointer;.link-with-menu-title-text{color:", colors/* default.text-gray */.Z["text-gray"], ";margin-right:8px;}.link-with-menu-title-icon{height:10px;width:10px;transition:transform 400ms ease;}}.link-with-menu-links-wrapper{display:flex;flex-direction:column;transition:height 400ms ease;.section-wrapper{margin:0 0 20px 12px;}.section-link{font-size:0.875rem;color:", colors/* default.asphalt */.Z.asphalt, ";font-weight:500;border-bottom:", SECTION_BORDER_BOTTOM, ";padding:16px 0;}.header-link{height:", MENU_ITEM_LINK_HEIGHT, ";display:flex;align-items:center;font-size:0.875rem;color:", colors/* default.tuna */.Z.tuna, ";text-decoration:none;.new-badge-component-wrapper{margin-left:8px;}&.subsection-link{height:48px;color:", colors/* default.asphalt */.Z.asphalt, ";display:flex;gap:16px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/header-menu/link-with-menu/link-with-sections-menu-component.js










var LinkWithSectionsMenuComponent = function(props) {
    var menuEl = (0,react.useRef)(null);
    var isOpen = props.isOpen, title = props.title, translate = props.translate, id = props.id, openLinksMenu = props.openLinksMenu, links = props.links;
    var openMenu = function() {
        var menuId = isOpen ? null : id;
        openLinksMenu(menuId);
    };
    var getStyle = function() {
        var _menuEl_current;
        // Don't break if menuEl is not yet set or clientHeight is not available for some reason
        // in such case, set height to auto (will disable animation tho)
        var collapseHeight = (menuEl === null || menuEl === void 0 ? void 0 : (_menuEl_current = menuEl.current) === null || _menuEl_current === void 0 ? void 0 : _menuEl_current.clientHeight) || "auto";
        return isOpen ? {
            height: collapseHeight
        } : {
            overflow: "hidden",
            height: 0
        };
    };
    var renderSection = function(param) {
        var section = param.section, sectionIndex = param.sectionIndex;
        var mobileTitle = section.mobileTitle, title = section.title, menuSectionItems = section.menuSectionItems, hideOnMobile = section.hideOnMobile;
        var onLinkClick = function(e, link) {
            (0,accessibility_service/* preventFocusOnMouseDown */.$R)(e);
            (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).CLICK_MAIN_NAV, {
                click_text: translate(link === null || link === void 0 ? void 0 : link.title),
                parent_category: link === null || link === void 0 ? void 0 : link.itemType
            });
        };
        return !hideOnMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "section-wrapper",
            children: [
                (mobileTitle || title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "section-link",
                    children: translate(mobileTitle || title)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: menuSectionItems.map(function(link, linkIndex) {
                        var linkTitle = link.title, url = link.url, isPopular = link.isPopular, badgeText = link.badgeText, badgeColorName = link.badgeColorName, badgeTextColorName = link.badgeTextColorName, badgeStrokeColorName = link.badgeStrokeColorName, openInNewTab = link.openInNewTab, MobileIcon = link.mobileIcon;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "header-link subsection-link",
                            href: url,
                            onMouseDown: function(e) {
                                return onLinkClick(e, link);
                            },
                            target: openInNewTab ? "_blank" : "_self",
                            rel: "noreferrer",
                            children: [
                                MobileIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileIcon, {}),
                                translate(linkTitle),
                                isPopular && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "new-badge-component-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_component/* default */.Z, {
                                        badgeText: translate(badgeText),
                                        badgeColorName: badgeColorName,
                                        badgeTextColorName: badgeTextColorName,
                                        badgeStrokeColorName: badgeStrokeColorName
                                    })
                                })
                            ]
                        }, "link_".concat(linkIndex));
                    })
                })
            ]
        }, "section_".concat(sectionIndex));
    };
    var onKeyDown = (0,react.useCallback)((0,accessibility_service/* generateOnKeyDownHandler */.vR)(openMenu), [
        isOpen,
        id
    ]);
    var style = (0,react.useMemo)(function() {
        return getStyle();
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLinkWithSectionsMenuComponent, {
        className: classnames_default()("link-with-menu-mobile-component", {
            "is-open": isOpen
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "link-with-menu-title-wrapper",
                tabIndex: 0,
                onClick: openMenu,
                onKeyDown: onKeyDown,
                onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R,
                "aria-label": translate(title),
                role: "button",
                "aria-haspopup": "menu",
                "aria-expanded": isOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "link-with-menu-title-text",
                        children: translate(title)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_down/* default */.Z, {
                        className: "link-with-menu-title-icon"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("link-with-menu-links-wrapper"),
                style: style,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: menuEl,
                    children: links.map(function(section, sectionIndex) {
                        return renderSection({
                            section: section,
                            sectionIndex: sectionIndex
                        });
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var link_with_sections_menu_component = ((0,generic_config_context/* withGenericConfig */.P)(LinkWithSectionsMenuComponent));

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/header-menu/header-menu-component.scss.js


var StyledHeaderMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1bfiei10"
})("height:100%;width:100%;background-color:", colors/* default.white */.Z.white, ";user-select:none;display:flex;flex-direction:column;padding-bottom:80px;padding:0px 32px 80px;overflow:auto;.download-mobile-app-component-wrapper{margin-top:32px;}.monday-link-wrapper{display:flex;gap:10px;flex-direction:row;align-items:center;justify-content:center;margin-top:28px;.picture-component{img{max-height:20px;vertical-align:bottom;}}.monday-link-text-wrapper{justify-content:center;vertical-align:middle;.secondary-button{line-height:24px;a{&.with-underline{background:none;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/header-menu/header-menu-component.js

















var HeaderMenuComponent = function(props) {
    var ref = (0,react.useState)(null), openedMenuId = ref[0], setOpenedMenuId = ref[1];
    var isMinisitePage = props.isMinisitePage, pageClusterConfig = props.pageClusterConfig, useProductMiniSiteConfig = props.useProductMiniSiteConfig, abTests = props.abTests, translate = props.translate, isTypeformDisabled = props.isTypeformDisabled;
    var SMALL_MONDAY_LOGO = "https://dapulse-res.cloudinary.com/image/upload/mobile_menu/Monday.png";
    var openLinksMenu = function(menuId) {
        setOpenedMenuId(menuId);
    };
    var getPricingPageLink = function() {
        var minisitePricingPageLink = null;
        if (isMinisitePage) {
            minisitePricingPageLink = (0,cluster_config_service/* getMiniSitePricingPageLink */.DJ)(pageClusterConfig, {
                useProductMiniSiteConfig: useProductMiniSiteConfig
            });
        }
        return minisitePricingPageLink || links/* PRICING_PAGE_LINK */.C9V;
    };
    var onMainLinkClick = function(title) {
        (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).CLICK_MAIN_NAV, {
            click_text: translate(title)
        });
    };
    var displayTypeform = (0,use_contact_cales_typeform/* useContactSalesTypeform */.O)({
        abTests: abTests,
        fallbackLink: links/* CONTACT_US_FROM_HEADER_PAGE_LINK */.lij
    }).displayTypeform;
    var onContactSalesClicked = (0,react.useCallback)(function() {
        !isTypeformDisabled && displayTypeform();
    }, [
        displayTypeform,
        isTypeformDisabled
    ]);
    var renderContactSalesMobileButton = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(link_component/* default */.Z, {
            title: "header.contactSales",
            onClickFunc: onContactSalesClicked,
            url: isTypeformDisabled ? links/* CONTACT_US_FROM_HEADER_PAGE_LINK */.lij : null
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderMenuComponent, {
        className: "header-menu-mobile-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_with_sections_menu_component, {
                id: base_header_service/* PRODUCTS_MENU_ID */.VG,
                title: "header.products",
                links: base_header_service/* mobileProductsSectionMenuItems */.VK,
                openLinksMenu: openLinksMenu,
                isOpen: openedMenuId === base_header_service/* PRODUCTS_MENU_ID */.VG
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_with_sections_menu_component, {
                id: base_header_service/* USE_CASES_MENU_ID */.sI,
                title: "header.teams",
                links: base_header_service/* SectionsHeadersMenuItemsMapping */.tS[base_header_service/* USE_CASES_MENU_ID */.sI],
                openLinksMenu: openLinksMenu,
                isOpen: openedMenuId === base_header_service/* USE_CASES_MENU_ID */.sI
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_with_sections_menu_component, {
                id: base_header_service/* FEATURES_MENU_ID */.Qc,
                title: "header.features",
                links: base_header_service/* SectionsHeadersMenuItemsMapping */.tS[base_header_service/* FEATURES_MENU_ID */.Qc],
                openLinksMenu: openLinksMenu,
                isOpen: openedMenuId === base_header_service/* FEATURES_MENU_ID */.Qc
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_with_sections_menu_component, {
                id: base_header_service/* RESOURCES_MENU_ID */.Gu,
                title: "header.resources",
                links: base_header_service/* SectionsHeadersMenuItemsMapping */.tS[base_header_service/* RESOURCES_MENU_ID */.Gu],
                openLinksMenu: openLinksMenu,
                isOpen: openedMenuId === base_header_service/* RESOURCES_MENU_ID */.Gu
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_component/* default */.Z, {
                title: "header.pricing",
                url: getPricingPageLink(),
                onClickFunc: function() {
                    return onMainLinkClick("header.pricing");
                }
            }),
            renderContactSalesMobileButton(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "download-mobile-app-component-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(download_mobile_app_component/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "monday-link-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                        src: SMALL_MONDAY_LOGO
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "monday-link-text-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, {
                            buttonText: translate("header.menuItem.backToHomePage"),
                            url: links/* ROOT_LINK */.yjY,
                            onClick: function() {
                                return onMainLinkClick("logo");
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var header_menu_component = ((0,generic_config_context/* withGenericConfig */.P)((0,ab_tests_context/* withAbTests */.k)(HeaderMenuComponent)));

// EXTERNAL MODULE: ./components/core/top-bar-new/hamburger-menu/hamburger-menu-component.js + 1 modules
var hamburger_menu_component = __webpack_require__(73418);
// EXTERNAL MODULE: ./segments/desktop/core-components/banner/banner.js + 2 modules
var banner = __webpack_require__(15814);
// EXTERNAL MODULE: ./constants/header-popup.js
var header_popup = __webpack_require__(61167);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/base-header-mobile-component.scss.js





var base_header_mobile_component_scss_BASIC_HEADER_HEIGHT = "".concat(constants/* default.BASIC_HEADER_HEIGHT */.Z.BASIC_HEADER_HEIGHT, "px");
var HEADER_MENU_HEIGHT = "calc(100% - ".concat(constants/* default.BASIC_HEADER_HEIGHT */.Z.BASIC_HEADER_HEIGHT - 1, "px)");
var HEADER_MENU_TRANSITION = "opacity ".concat(base_header_constants/* default.HEADER_MENU_TRANSITION_DURATION */.Z.HEADER_MENU_TRANSITION_DURATION, "ms ease, visibility ").concat(base_header_constants/* default.HEADER_MENU_TRANSITION_DURATION */.Z.HEADER_MENU_TRANSITION_DURATION, "ms ease;");
var BASE_HEADER_HEIGHT_WITH_SECONDARY = "".concat(constants/* default.MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT */.Z.MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT + constants/* default.MOBILE_MINI_SITE_SECONDARY_HEADER_HEIGHT */.Z.MOBILE_MINI_SITE_SECONDARY_HEADER_HEIGHT, "px");
var MOBILE_MINISITE_HEADER_MENU_HEIGHT = "calc(100% - ".concat(constants/* default.MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT */.Z.MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT - 1, "px)");
var MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT = "".concat(constants/* default.MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT */.Z.MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT, "px");
var StyledBaseHeaderMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("header", {
    target: "e16c8k6m0"
})("width:100%;height:", base_header_mobile_component_scss_BASIC_HEADER_HEIGHT, ";&.secondary-header{height:", BASE_HEADER_HEIGHT_WITH_SECONDARY, ";}&.with-cluster-logo:not(.secondary-header){height:", MOBILE_MINISITE_HEADER_MENU_HEIGHT, ";}&.with-cluster-logo{.header-menu-component-wrapper{top:", constants/* default.MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT */.Z.MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT - 1, "px;height:", MOBILE_MINISITE_HEADER_MENU_HEIGHT, ";}.mobile-basic-header{height:", MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT, ";.basic-header-content-wrapper{height:", MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT, ";img{height:", MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT, ";}.basic-header-content{height:", MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT, ";justify-content:space-between;padding-left:24px;padding-right:24px;.main-logo-wrapper{height:100%;a{height:100%;display:flex;.picture-component{display:flex;align-items:center;.base-header-monday-logo-image{max-width:calc(100% - 32px);height:unset;max-height:60px;margin-right:0;}}}}}}}.mobile-menu-right-section{flex-grow:0;.mobile-header-content{.hamburger-menu{margin:0;}}}}&.sticky-signup{.basic-header-component{.basic-header-content-wrapper{.basic-header-content{padding:0 16px;@media (max-width:", vp_sizes/* MOBILE_SMALL_PHONE_MAX_WIDTH */.W8, "){padding:0 12px;.mobile-header-content{.hamburger-menu{width:22px;}}}.mobile-menu-right-section{.sticky-signup-wrapper{@media (max-width:", vp_sizes/* SMALL_MOBILE_QUERY_INCLUDED_MAX_WIDTH */.JI, "){display:none;}.regular-button{.button-component{padding:8px 12px 9.5px 12px;font-size:0.8125rem;font-weight:300;}}}.mobile-header-content{.hamburger-menu{margin-left:16px;margin-right:0;}}}}}}}.mobile-menu-right-section{flex-grow:1;display:flex;justify-content:flex-end;.mobile-header-content{.hamburger-menu{span{height:2px !important;}}}}.header-menu-component-wrapper{position:fixed;z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";top:", constants/* default.BASIC_HEADER_HEIGHT */.Z.BASIC_HEADER_HEIGHT - 1 + "px", ";opacity:0;height:", HEADER_MENU_HEIGHT, ";width:100%;visibility:hidden;transition:", HEADER_MENU_TRANSITION, ";&.is-open{opacity:1;visibility:visible;}@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, "){max-width:100vw;}}");

// EXTERNAL MODULE: ./services/dom-utils-service.js
var dom_utils_service = __webpack_require__(44566);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/secondary-header/secondary-header-mobile/secondary-header-mobile-component.scss.js



var OPACITY_WIDTH = "48px";
var SECONDARY_HEIGHT = "".concat(constants/* default.MOBILE_MINI_SITE_SECONDARY_HEADER_HEIGHT */.Z.MOBILE_MINI_SITE_SECONDARY_HEADER_HEIGHT, "px");
var StyledSecondaryHeaderMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("nav", {
    target: "ekpqxv50"
})("height:", SECONDARY_HEIGHT, ";width:100%;outline:solid 1px;outline-color:", colors/* default.border-gray */.Z["border-gray"], ';position:fixed;background-color:#fff;z-index:555;box-shadow:0px 4px 40px rgba(0,0,0,0.08);&.scroll-end{&::after{opacity:0;}}&::after{content:"";position:absolute;right:0;top:0;height:100%;width:', OPACITY_WIDTH, ";background:linear-gradient(90deg,rgba(255,255,255,0) -140%,#ffffff 180%);opacity:1;pointer-events:none;}.links-wrapper{display:flex;overflow:scroll;height:100%;&::-webkit-scrollbar{display:none;}.secondary-link-item-wrapper{white-space:nowrap;display:flex;&:first-child{padding-left:8px;}&:last-child{.secondary-link-item-component{margin-right:24px;}}.secondary-link-item-component{padding-left:8px;padding-right:8px;margin:0 8px;font-size:0.8125rem;&:hover{color:", colors/* default.asphalt */.Z.asphalt, ";}}}}");

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/secondary-header/secondary-header-mobile/secondary-header-mobile-component.js










var SCROLL_TRESHOLD = 10;
var INITIAL_SCROLL_FOR_OUTER_VIEWPORT_LINK = 64;
var SecondaryHeaderMobileComponent = function(props) {
    var ref = (0,react.useState)(false), isScrollEnded = ref[0], setIsScrollEnded = ref[1];
    var selectedLinkRef = (0,react.useRef)(null);
    var linksWrapperRef = (0,react.useRef)(null);
    var pageClusterConfig = props.pageClusterConfig, router = props.router, useProductMiniSiteConfig = props.useProductMiniSiteConfig;
    var ref1 = (0,react.useState)(null), linksWrapperScrollWidth = ref1[0], setLinksWrapperScrollWidth = ref1[1];
    var ref2 = (0,react.useState)(null), linksWrapperOffsetWidth = ref2[0], setLinksWrapperOffsetWidth = ref2[1];
    (0,react.useEffect)(function() {
        if (selectedLinkRef === null || selectedLinkRef === void 0 ? void 0 : selectedLinkRef.current) {
            (0,dom_utils_service.isNodeFullyInView)(selectedLinkRef === null || selectedLinkRef === void 0 ? void 0 : selectedLinkRef.current).then(function(inView) {
                if (!inView) {
                    selectedLinkRef.current.scrollIntoView(true);
                    linksWrapperRef.current.scrollLeft += INITIAL_SCROLL_FOR_OUTER_VIEWPORT_LINK;
                }
            });
        }
        linksWrapperRef.current.addEventListener("scroll", scrollListenerForSecondaryMenuRemoveFade, {
            passive: true
        });
    }, []);
    (0,react.useEffect)(function() {
        var _linksWrapperRef_current, _linksWrapperRef_current1;
        setLinksWrapperScrollWidth((_linksWrapperRef_current = linksWrapperRef.current) === null || _linksWrapperRef_current === void 0 ? void 0 : _linksWrapperRef_current.scrollWidth);
        setLinksWrapperOffsetWidth((_linksWrapperRef_current1 = linksWrapperRef.current) === null || _linksWrapperRef_current1 === void 0 ? void 0 : _linksWrapperRef_current1.offsetWidth);
    }, [
        linksWrapperRef
    ]);
    var scrollListenerForSecondaryMenuRemoveFade = function() {
        var scrollLeft = linksWrapperRef.current.scrollLeft;
        if (scrollLeft + SCROLL_TRESHOLD >= linksWrapperScrollWidth - linksWrapperOffsetWidth) {
            setIsScrollEnded(true);
        } else if (isScrollEnded) {
            setIsScrollEnded(false);
        }
    };
    var scrollToLinkItemOnClick = function(e) {
        e.target.scrollIntoView(true);
    };
    var renderLinks = function() {
        var links = (0,cluster_config_service/* getMiniSiteLinks */.J9)(pageClusterConfig, {
            useProductMiniSiteConfig: useProductMiniSiteConfig
        });
        return links.map(function(link, index) {
            var isSelected = (0,url.isSameUrlWithoutQueryParams)(link === null || link === void 0 ? void 0 : link.url, router === null || router === void 0 ? void 0 : router.asPath);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "secondary-link-item-wrapper",
                ref: isSelected ? selectedLinkRef : null,
                onClick: scrollToLinkItemOnClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_link_item_component, {
                    url: link === null || link === void 0 ? void 0 : link.url,
                    title: link === null || link === void 0 ? void 0 : link.text,
                    isSelected: isSelected
                })
            }, index);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSecondaryHeaderMobileComponent, {
        "aria-label": "Secondary",
        className: classnames_default()("secondary-header-mobile-component", {
            "scroll-end": isScrollEnded
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "links-wrapper",
            ref: linksWrapperRef,
            children: renderLinks()
        })
    });
};
/* harmony default export */ var secondary_header_mobile_component = ((0,router.withRouter)((0,generic_config_context/* withGenericConfig */.P)(SecondaryHeaderMobileComponent)));

;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-mobile/base-header-mobile-component.js





function base_header_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




















var SCROLL_MODE_THRESHOLD = 2; // The amount of pixels from the top that will trigger the scrolled mode of the navbar
var MONDAY_WHITE_LOGO = "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/img/monday_logo_white.png";
var BaseHeaderMobileComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseHeaderMobileComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseHeaderMobileComponent);
    function BaseHeaderMobileComponent(props) {
        (0,_class_call_check/* default */.Z)(this, BaseHeaderMobileComponent);
        var _this;
        _this = _super.call(this, props);
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "isScrolled", function() {
            var _window, _document_documentElement, _document;
            return (((_window = window) === null || _window === void 0 ? void 0 : _window.pageYOffset) || ((_document = document) === null || _document === void 0 ? void 0 : (_document_documentElement = _document.documentElement) === null || _document_documentElement === void 0 ? void 0 : _document_documentElement.scrollTop)) >= SCROLL_MODE_THRESHOLD;
        });
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "scrollListener", function(event) {
            var isScrolled = _this.state.isScrolled;
            var isInScrollMode = _this.isScrolled();
            if (isInScrollMode !== isScrolled) {
                _this.setState({
                    isScrolled: isInScrollMode
                });
            }
        });
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "shouldDisplayClusterizedLogo", function() {
            var _props = _this.props, pageClusterConfig = _props.pageClusterConfig, isSecondaryMenuNeeded = _props.isSecondaryMenuNeeded, pageClusterId = _props.pageClusterId, pageSubClusterId = _props.pageSubClusterId, useProductMiniSiteConfig = _props.useProductMiniSiteConfig;
            if (pageClusterConfig && (isSecondaryMenuNeeded || pageClusterId || pageSubClusterId)) {
                return !!(0,cluster_config_service/* getMiniSiteLogo */.o8)(pageClusterConfig, {
                    useProductMiniSiteConfig: useProductMiniSiteConfig
                });
            }
            return false;
        });
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getMondayLogo", function() {
            var _props = _this.props, pageClusterConfig = _props.pageClusterConfig, useProductMiniSiteConfig = _props.useProductMiniSiteConfig;
            var _props1 = _this.props, logoHref = _props1.logoHref, logoSrc = _props1.logoSrc;
            if (_this.shouldDisplayClusterizedLogo()) {
                var _pageClusterConfig_mini_site_logo, _pageClusterConfig_mini_site;
                var useDesktopLogoInMobile = (pageClusterConfig === null || pageClusterConfig === void 0 ? void 0 : (_pageClusterConfig_mini_site = pageClusterConfig.mini_site) === null || _pageClusterConfig_mini_site === void 0 ? void 0 : (_pageClusterConfig_mini_site_logo = _pageClusterConfig_mini_site.logo) === null || _pageClusterConfig_mini_site_logo === void 0 ? void 0 : _pageClusterConfig_mini_site_logo.useDesktopLogoInMobile) === "true";
                return useDesktopLogoInMobile ? (0,cluster_config_service/* getClusterDesktopLogo */.k7)(pageClusterConfig, {
                    useProductMiniSiteConfig: useProductMiniSiteConfig
                }) : (0,cluster_config_service/* getMiniSiteLogo */.o8)(pageClusterConfig, {
                    useProductMiniSiteConfig: useProductMiniSiteConfig
                });
            }
            return {
                src: logoSrc,
                url: logoHref
            };
        });
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "enterMobileMenuAbTest", function() {
            // leaving for future menu ab tests
            var abTests = _this.props.abTests;
        });
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "toogleOpenMenu", function(isMenuOpen) {
            if (isMenuOpen) {
                var _document;
                _this._basicHeader.forceShadow();
                _this.enterMobileMenuAbTest();
                // Remove focus when opening the menu
                // Should close all native autocompletes
                if ((_document = document) === null || _document === void 0 ? void 0 : _document.activeElement) {
                    document.activeElement.blur();
                }
            } else {
                // Close all tabs in link menus in case the menu will be closed
                setTimeout(function() {
                    var _this__headerMenu;
                    return (_this__headerMenu = _this._headerMenu) === null || _this__headerMenu === void 0 ? void 0 : _this__headerMenu.openLinksMenu(null);
                }, base_header_constants/* default.HEADER_MENU_TRANSITION_DURATION */.Z.HEADER_MENU_TRANSITION_DURATION);
                _this._basicHeader.unforceShadow();
            }
            (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).CLICK_MAIN_NAV, {
                click_text: "logo"
            });
            _this.setState({
                isMenuOpen: isMenuOpen
            });
        });
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderLogoPopupIfNeeded", function() {
            var _props = _this.props, translate = _props.translate, logoPopup = _props.logoPopup, localeId = _props.localeId;
            var popupData = header_popup/* HEADER_POPUP_DATA */.Yq[logoPopup];
            if (!popupData) return null;
            var key = popupData.mobileTextKey || popupData.textKey;
            var imageSource = popupData.mobileImageSrc || popupData.gifSrc;
            var bannerText = translate(key).replace("<br>", " "); // desktop popup text can have specific breaks
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(banner/* default */.Z, {
                withSignupButton: false,
                bannerText: bannerText,
                bannerLinkData: {
                    text: translate(popupData.ctaKey),
                    src: popupData.getLink(localeId)
                },
                theme: popupData.bannerTheme,
                bannerleftImage: imageSource
            });
        });
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderSignup", function() {
            var translate = _this.props.translate;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sticky-signup-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(regular_button/* default */.Z, {
                    buttonText: translate("signup.cta"),
                    url: links/* NEW_SOFT_SIGNUP_LINK */.SXZ,
                    color: color_consts.WORK_OS_IRIS_COLOR_NAME
                })
            });
        });
        base_header_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "shouldShowStickySignup", function() {
            var _props = _this.props, abTests = _props.abTests, mobileStickySignup = _props.mobileStickySignup;
            if (_this.shouldDisplayClusterizedLogo()) return false;
            if (mobileStickySignup) return true;
            return (0,acquisition_ab_test_service.shouldGetMobileStickySignupAbTest)(abTests, true);
        });
        _this.state = {
            isMenuOpen: false,
            isScrolled: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(BaseHeaderMobileComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                window.addEventListener("scroll", this.scrollListener);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("scroll", this.scrollListener);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, showMenu = _props.showMenu, isSecondaryMenuNeeded = _props.isSecondaryMenuNeeded, translate = _props.translate, shouldUseDynamicColor = _props.shouldUseDynamicColor;
                var isMenuOpen = this.state.isMenuOpen;
                var logo = this.getMondayLogo();
                var displayClusterLogo = this.shouldDisplayClusterizedLogo();
                var renderStickySignup = this.shouldShowStickySignup();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBaseHeaderMobileComponent, {
                            className: classnames_default()("base-header-mobile-component", {
                                "secondary-header": isSecondaryMenuNeeded,
                                "with-cluster-logo": displayClusterLogo,
                                "sticky-signup": renderStickySignup
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(basic_header_component/* default */.Z, {
                                    ref: function(element) {
                                        return _this._basicHeader = element;
                                    },
                                    showMenu: showMenu,
                                    imageHref: logo.url,
                                    imageSrc: logo.src,
                                    imageAlt: logo.alt,
                                    isMobile: true,
                                    isSecondaryMenuNeeded: isSecondaryMenuNeeded,
                                    className: "mobile-basic-header",
                                    isMenuOpen: isMenuOpen,
                                    shouldUseDynamicColor: shouldUseDynamicColor,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mobile-menu-right-section",
                                        children: [
                                            renderStickySignup && this.renderSignup(),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mobile-header-content",
                                                "aria-label": translate("header.mainMenu"),
                                                role: "navigation",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hamburger_menu_component/* default */.Z, {
                                                    changeStateCallback: this.toogleOpenMenu,
                                                    isOpen: isMenuOpen
                                                })
                                            })
                                        ]
                                    })
                                }),
                                isSecondaryMenuNeeded && /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_header_mobile_component, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("header-menu-component-wrapper", {
                                        "is-open": isMenuOpen
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu_component, {
                                        ref: function(element) {
                                            return _this._headerMenu = element;
                                        },
                                        isMinisitePage: isSecondaryMenuNeeded
                                    })
                                })
                            ]
                        }),
                        this.renderLogoPopupIfNeeded()
                    ]
                });
            }
        }
    ]);
    return BaseHeaderMobileComponent;
}(react.PureComponent);
/* harmony default export */ var base_header_mobile_component = ((0,generic_config_context/* withGenericConfig */.P)((0,ab_tests_context/* withAbTests */.k)(BaseHeaderMobileComponent)));

// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/default-props.js
var default_props = __webpack_require__(32777);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-component.js




function base_header_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function base_header_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            base_header_component_define_property(target, key, source[key]);
        });
    }
    return target;
}








var BaseHeaderComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseHeaderComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseHeaderComponent);
    function BaseHeaderComponent(props) {
        (0,_class_call_check/* default */.Z)(this, BaseHeaderComponent);
        var _this;
        _this = _super.call(this, props);
        var isSecondaryMenuNeeded = props.isSecondaryMenuNeeded;
        _this.isSecondaryMenuNeeded = isSecondaryMenuNeeded;
        return _this;
    }
    (0,_create_class/* default */.Z)(BaseHeaderComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.trackIsMobileOrTablet();
            }
        },
        {
            key: "trackIsMobileOrTablet",
            value: function trackIsMobileOrTablet() {
                var mobileWrapper = document.querySelector(".mobile-wrapper");
                if (mobileWrapper) {
                    var isMobileWrapperRendered = mobileWrapper.offsetParent !== null;
                    if (isMobileWrapperRendered) BigBrain("track", bigbrain_event_types.MOBILE_OR_TABLE_VIEW, {
                        kind: location.pathname
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBaseHeaderComponent, {
                    className: "base-header-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "desktop-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_header_desktop_component, base_header_component_object_spread({
                                isSecondaryMenuNeeded: this.isSecondaryMenuNeeded
                            }, this.props))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_header_mobile_component, base_header_component_object_spread({
                                isSecondaryMenuNeeded: this.isSecondaryMenuNeeded
                            }, this.props))
                        })
                    ]
                });
            }
        }
    ]);
    return BaseHeaderComponent;
}(react.PureComponent);
BaseHeaderComponent.defaultProps = default_props/* default */.Z;
/* harmony default export */ var base_header_component = ((0,generic_config_context/* withGenericConfig */.P)(BaseHeaderComponent));


/***/ }),

/***/ 32777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75650);
/* harmony import */ var _constants_links__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27639);


/* harmony default export */ __webpack_exports__["Z"] = ({
    showMenu: true,
    hideLogin: false,
    showButton: true,
    hideLanguagePicker: false,
    logoHref: _constants_links__WEBPACK_IMPORTED_MODULE_1__/* .ROOT_LINK */ .yjY,
    logoSrc: _constants_links__WEBPACK_IMPORTED_MODULE_1__/* .MONDAY_LOGO_SRC */ .Onk,
    buttonConfig: {
        buttonType: segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_0__/* .SIGNUP_BUTTON_TYPE */ .ge
    }
});


/***/ })

}]);